import { useState, useRef, useEffect } from "react";

const STORE_KEY = "tts_data_v1";
const STORE_7D_KEY = "tts_data_7d_v1";
const STORE_28D_KEY = "tts_data_28d_v1";
const COUNT_KEY = "tts_refresh_count";
const PROD_KEY = "tts_shop_products_v3";
const HOME_PROD_KEY = "tts_home_products_v1";
const ORDER_KEY = "tts_orders_v1";
const FINANCE_KEY = "tts_finance_v1";
const BASE = { gmv: 25.75, gmvDelta: "+43.6%", orders: 3, ordersDelta: "+50.0%", pageViews: 0, pageViewsDelta: "--%", visitors: 44, visitorsDelta: "+120.0%", healthScore: "200", pendingShip: "2", lowStock: "0", pendingReview: "0", afterSale: "0", rejected: "0", appealable: "0", dailyOrderLimit: "3/5", maxProducts: "12/20", shopName: "Neighbor Gems" };

// ── IndexedDB 图片存储（容量不受限）──────────────────────────────────────────
const IDB_NAME = "tts_images_db";
const IDB_STORE = "images";
let _idb = null;

function getIDB() {
  if (_idb) return Promise.resolve(_idb);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(IDB_NAME, 1);
    req.onupgradeneeded = e => e.target.result.createObjectStore(IDB_STORE);
    req.onsuccess = e => { _idb = e.target.result; resolve(_idb); };
    req.onerror = () => reject(req.error);
  });
}
function idbSave(key, value) {
  return getIDB().then(db => new Promise((resolve, reject) => {
    const tx = db.transaction(IDB_STORE, "readwrite");
    tx.objectStore(IDB_STORE).put(value, key);
    tx.oncomplete = resolve;
    tx.onerror = () => reject(tx.error);
  })).catch(()=>{});
}
function idbLoad(key) {
  return getIDB().then(db => new Promise((resolve) => {
    const req = db.transaction(IDB_STORE, "readonly").objectStore(IDB_STORE).get(key);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => resolve(null);
  })).catch(()=>null);
}
function idbDelete(key) {
  return getIDB().then(db => new Promise((resolve) => {
    const tx = db.transaction(IDB_STORE, "readwrite");
    tx.objectStore(IDB_STORE).delete(key);
    tx.oncomplete = resolve;
    tx.onerror = resolve;
  })).catch(()=>{});
}

function loadProds() {
  try {
    const s = localStorage.getItem(PROD_KEY);
    return s ? JSON.parse(s) : null;
  } catch { return null; }
}
function saveProds(ps) {
  try {
    // Save product data (no images) to localStorage
    localStorage.setItem(PROD_KEY, JSON.stringify(ps.map(p => ({ ...p, img: null }))));
    // Save images to IndexedDB
    ps.forEach(p => {
      if (p.img) idbSave(PROD_KEY + '_img_' + p.id, p.img);
      else idbDelete(PROD_KEY + '_img_' + p.id);
    });
  } catch {}
}
async function loadProdsWithImages(prods) {
  return Promise.all(prods.map(async p => {
    const img = await idbLoad(PROD_KEY + '_img_' + p.id);
    return { ...p, img: img || null };
  }));
}

function loadHomeProds() {
  try {
    const s = localStorage.getItem(HOME_PROD_KEY);
    return s ? JSON.parse(s) : null;
  } catch { return null; }
}
function saveHomeProds(ps) {
  try {
    localStorage.setItem(HOME_PROD_KEY, JSON.stringify(ps.map(p => ({ ...p, img: null }))));
    ps.forEach(p => {
      if (p.img) idbSave(HOME_PROD_KEY + '_img_' + p.id, p.img);
      else idbDelete(HOME_PROD_KEY + '_img_' + p.id);
    });
  } catch {}
}
async function loadHomeProdsWithImages(prods) {
  return Promise.all(prods.map(async p => {
    const img = await idbLoad(HOME_PROD_KEY + '_img_' + p.id);
    return { ...p, img: img || null };
  }));
}
function loadFinance() { try { const s=localStorage.getItem(FINANCE_KEY); return s?JSON.parse(s):null; } catch { return null; } }
function saveFinance(f) { try { localStorage.setItem(FINANCE_KEY, JSON.stringify(f)); } catch {} }

function loadOrders() { try { const s=localStorage.getItem(ORDER_KEY); return s?JSON.parse(s):null; } catch { return null; } }
function saveOrders(os) { try { localStorage.setItem(ORDER_KEY, JSON.stringify(os)); } catch {} }

// Generate a random order
function generateOrder(addOrders) {
  const names = ["ashley.w","mike_j","sarah.k","linda92","tom_b","grace.m","kevin_x","nina_p","jason.h","emma_d","ryan.c","olivia_m","noah_w","sophia_t","liam_b"];
  const fullNames = ["Ashley Wilson","Mike Johnson","Sarah Kim","Linda Brown","Tom Baker","Grace Miller","Kevin Xu","Nina Park","Jason Hall","Emma Davis","Ryan Chen","Olivia Moore","Noah White","Sophia Taylor","Liam Brooks"];
  const methods = ["标准运输","加急运输","标准运输","标准运输","优先运输"];
  const usps = ["9200190391695322114","9200190391695433221","9200190391695567890","9200190391695112334","9200190391695998877"];
  const prices = ["$8.99","$12.50","$15.84","$9.51","$11.23","$7.88","$14.32","$18.50","$6.75","$22.00"];
  const idx = Math.floor(Math.random()*names.length);
  const now = new Date();
  const dateStr = now.getFullYear()+"/"+(String(now.getMonth()+1).padStart(2,"0"))+"/"+String(now.getDate()).padStart(2,"0")+" "+String(now.getHours()).padStart(2,"0")+":"+String(now.getMinutes()).padStart(2,"0")+":"+String(now.getSeconds()).padStart(2,"0");
  const orderId = "5774"+Math.floor(Math.random()*9000000000+1000000000).toString();
  const trackSuffix = Math.floor(Math.random()*900+100).toString();
  const deadlineDate = new Date(now.getTime()+7*24*60*60*1000);
  const deadlineStr = deadlineDate.getFullYear()+"/"+(String(deadlineDate.getMonth()+1).padStart(2,"0"))+"/"+String(deadlineDate.getDate()).padStart(2,"0");
  return {
    id: orderId,
    date: dateStr,
    customer: names[idx],
    customerName: fullNames[idx],
    items: Math.floor(Math.random()*2+1)+" 件商品",
    status: "待发货",
    logistics: "TikTok 物流",
    trackNo: "USPS, "+usps[Math.floor(Math.random()*usps.length)]+trackSuffix,
    deadline: "送达截止日期: "+deadlineStr,
    method: methods[Math.floor(Math.random()*methods.length)],
    total: prices[Math.floor(Math.random()*prices.length)]
  };
}

function loadData7d() { try { const s = localStorage.getItem(STORE_7D_KEY); return s ? JSON.parse(s) : { gmv: 3250.50, gmvDelta: "+12450.0%", orders: 892, ordersDelta: "+29633.3%", pageViews: 48320, pageViewsDelta: "+580000.0%", visitors: 2841, visitorsDelta: "+6375.0%" }; } catch { return null; } }
function loadData28d() { try { const s = localStorage.getItem(STORE_28D_KEY); return s ? JSON.parse(s) : { gmv: 11820.30, gmvDelta: "+45862.0%", orders: 3241, ordersDelta: "+107933.3%", pageViews: 195600, pageViewsDelta: "+2347000.0%", visitors: 10284, visitorsDelta: "+23100.0%" }; } catch { return null; } }
function saveData7d(d) { try { localStorage.setItem(STORE_7D_KEY, JSON.stringify(d)); } catch {} }
function saveData28d(d) { try { localStorage.setItem(STORE_28D_KEY, JSON.stringify(d)); } catch {} }
function loadData() { try { const s = localStorage.getItem(STORE_KEY); return s ? JSON.parse(s) : {...BASE}; } catch { return {...BASE}; } }
function saveData(d) { try { localStorage.setItem(STORE_KEY, JSON.stringify(d)); } catch {} }
function getCount() { try { return parseInt(localStorage.getItem(COUNT_KEY) || "0"); } catch { return 0; } }
function setCount(n) { try { localStorage.setItem(COUNT_KEY, String(n)); } catch {} }
function growData(d) {
  const addGmv = parseFloat((Math.random()*18+8).toFixed(2));
  const addOrders = Math.floor(Math.random()*3+1);
  const addViews = Math.floor(Math.random()*120+40);
  const addVisitors = Math.floor(Math.random()*8+2);
  const newGmv = parseFloat((parseFloat(d.gmv)+addGmv).toFixed(2));
  const newOrders = parseInt(d.orders)+addOrders;
  const newViews = parseInt(d.pageViews)+addViews;
  const newVisitors = parseInt(d.visitors)+addVisitors;
  // Add new orders to order list
  const existingOrders = loadOrders() || [];
  const newOrdersList = [];
  for (let i=0; i<addOrders; i++) { newOrdersList.push(generateOrder(addOrders)); }
  saveOrders([...newOrdersList, ...existingOrders]);
  const newPendingShip = parseInt(d.pendingShip)+addOrders;
  const limitParts = (d.dailyOrderLimit || '3/5').split('/');
  const denominator = limitParts[1] || '5';
  const newDailyLimit = newOrders + '/' + denominator;
  // Sync GMV to finance unsettled
  try {
    const savedFinance = JSON.parse(localStorage.getItem(FINANCE_KEY)||'{}');
    savedFinance.unsettled = newGmv.toFixed(2);
    localStorage.setItem(FINANCE_KEY, JSON.stringify(savedFinance));
  } catch {}
  return { ...d, gmv: newGmv, gmvDelta: "+"+((( newGmv-25.75)/25.75)*100+43.6).toFixed(1)+"%", orders: newOrders, ordersDelta: "+"+((( newOrders-3)/3)*100+50).toFixed(1)+"%", pageViews: newViews, pageViewsDelta: "+"+(newViews*1.2).toFixed(1)+"%", visitors: newVisitors, visitorsDelta: "+"+((( newVisitors-44)/44)*100+120).toFixed(1)+"%", pendingShip: String(newPendingShip), dailyOrderLimit: newDailyLimit };
}
function growData7d(d) {
  return { ...d,
    gmv: parseFloat((parseFloat(d.gmv) + Math.random()*120+30).toFixed(2)),
    orders: parseInt(d.orders) + Math.floor(Math.random()*15+5),
    pageViews: parseInt(d.pageViews) + Math.floor(Math.random()*800+200),
    visitors: parseInt(d.visitors) + Math.floor(Math.random()*60+20),
  };
}
function growData28d(d) {
  return { ...d,
    gmv: parseFloat((parseFloat(d.gmv) + Math.random()*450+100).toFixed(2)),
    orders: parseInt(d.orders) + Math.floor(Math.random()*55+15),
    pageViews: parseInt(d.pageViews) + Math.floor(Math.random()*3000+800),
    visitors: parseInt(d.visitors) + Math.floor(Math.random()*220+60),
  };
}
const currentCount = getCount()+1;
let initialData = loadData();
if (currentCount >= 3) {
  initialData = growData(initialData); saveData(initialData);
  const d7 = loadData7d(); saveData7d(growData7d(d7));
  const d28 = loadData28d(); saveData28d(growData28d(d28));
  setCount(0);
} else { setCount(currentCount); }

const INIT_SHOP_PRODUCTS = [
  { id:1, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240279823929040952", msku:"商家 SKU: S230", sales:"已售出 1 件", salesViews:"浏览次数: 503", salesAmt:"销售额: $4.30", status:"在售", statusTime:"2026/06/05 22:27", stock:44, price:"$17.77", origPrice:"", promoPrice:"促销价: $3.55", quality:"低质", qualityLevel:1 },
  { id:2, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240279723432760 8", msku:"商家 SKU: S230", sales:"已售出 3 件", salesViews:"浏览次数: 10135", salesAmt:"销售额: $23.05", status:"在售", statusTime:"2026/06/05 01:15", stock:28, price:"$17.77", origPrice:"", promoPrice:"促销价: $3.55", quality:"优质", qualityLevel:3 },
  { id:3, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281911679800 8", msku:"商家 SKU: K907", sales:"已售出 1 件", salesViews:"浏览次数: 1255", salesAmt:"销售额: $9.58", status:"在售", statusTime:"2026/06/05 00:18", stock:206, price:"$15.21", origPrice:"", promoPrice:"促销价: $3.04", quality:"优质", qualityLevel:3 },
  { id:4, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240618038162642 4", msku:"商家 SKU: LIS333", sales:"已售出 3 件", salesViews:"浏览次数: 3455", salesAmt:"销售额: $14.62", status:"在售", statusTime:"2026/06/04 23:58", stock:391, price:"$12.77", origPrice:"标价: $34.00", promoPrice:"促销价: $2.55", quality:"优质", qualityLevel:3 },
  { id:5, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281885150528 0", msku:"商家 SKU: K888", sales:"已售出 0 件", salesViews:"浏览次数: 162", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/06/04 23:54", stock:31, price:"$17.12", origPrice:"", promoPrice:"促销价: $3.42", quality:"优质", qualityLevel:3 },
  { id:6, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282383250642 4", msku:"商家 SKU: K916", sales:"已售出 0 件", salesViews:"浏览次数: 136", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/06/01 15:18", stock:176, price:"$12.12", origPrice:"", promoPrice:"促销价: $2.42", quality:"优质", qualityLevel:3 },
  { id:7, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281894850156 0", msku:"商家 SKU: S221", sales:"已售出 1 件", salesViews:"浏览次数: 500", salesAmt:"销售额: $3.27", status:"在售", statusTime:"2026/05/28 05:36", stock:45, price:"$12.31", origPrice:"", promoPrice:"促销价: $2.46", quality:"优质", qualityLevel:3 },
  { id:8, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281970157573 6", msku:"商家 SKU: K905", sales:"已售出 1 件", salesViews:"浏览次数: 840", salesAmt:"销售额: $8.37", status:"在售", statusTime:"2026/05/28 05:32", stock:287, price:"$21.21", origPrice:"", promoPrice:"促销价: $4.24", quality:"优质", qualityLevel:3 },
  { id:9, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281901141612 0", msku:"商家 SKU: K905", sales:"已售出 2 件", salesViews:"浏览次数: 346", salesAmt:"销售额: $3.78", status:"在售", statusTime:"2026/05/28 05:22", stock:107, price:"$19.22", origPrice:"", promoPrice:"促销价: $3.84", quality:"优质", qualityLevel:3 },
  { id:10, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282373171205 6", msku:"商家 SKU: K918", sales:"已售出 0 件", salesViews:"浏览次数: 73", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:21", stock:236, price:"$12.12", origPrice:"", promoPrice:"促销价: $2.42", quality:"优质", qualityLevel:3 },
  { id:11, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281894823941 6", msku:"商家 SKU: K906", sales:"已售出 0 件", salesViews:"浏览次数: 371", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:19", stock:30, price:"$9.12", origPrice:"", promoPrice:"促销价: $1.82", quality:"优质", qualityLevel:3 },
  { id:12, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282383270303 2", msku:"商家 SKU: K906", sales:"已售出 0 件", salesViews:"浏览次数: 466", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:16", stock:92, price:"$9.12", origPrice:"", promoPrice:"促销价: $1.82", quality:"优质", qualityLevel:3 },
  { id:13, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240281901197355 2", msku:"商家 SKU: K888", sales:"已售出 0 件", salesViews:"浏览次数: 214", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:14", stock:58, price:"$14.54", origPrice:"", promoPrice:"促销价: $2.91", quality:"优质", qualityLevel:3 },
  { id:14, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282372505246 4", msku:"商家 SKU: K907", sales:"已售出 0 件", salesViews:"浏览次数: 189", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:12", stock:143, price:"$15.21", origPrice:"", promoPrice:"促销价: $3.04", quality:"优质", qualityLevel:3 },
  { id:15, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282372619001 6", msku:"商家 SKU: K916", sales:"已售出 0 件", salesViews:"浏览次数: 97", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:10", stock:84, price:"$12.12", origPrice:"", promoPrice:"促销价: $2.42", quality:"优质", qualityLevel:3 },
  { id:16, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282383135024 0", msku:"商家 SKU: LIS333", sales:"已售出 0 件", salesViews:"浏览次数: 523", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:08", stock:267, price:"$12.77", origPrice:"", promoPrice:"促销价: $2.55", quality:"优质", qualityLevel:3 },
  { id:17, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282372898480 8", msku:"商家 SKU: K911", sales:"已售出 0 件", salesViews:"浏览次数: 341", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:06", stock:119, price:"$16.13", origPrice:"", promoPrice:"促销价: $3.23", quality:"优质", qualityLevel:3 },
  { id:18, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282372747529 6", msku:"商家 SKU: S328", sales:"已售出 0 件", salesViews:"浏览次数: 445", salesAmt:"销售额: $0.00", status:"在售", statusTime:"2026/05/28 05:04", stock:72, price:"$7.33", origPrice:"", promoPrice:"促销价: $1.99", quality:"低质", qualityLevel:1 },
  { id:19, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282383060384 0", msku:"商家 SKU: K907", sales:"已售出 1 件", salesViews:"浏览次数: 628", salesAmt:"销售额: $8.47", status:"在售", statusTime:"2026/05/27 22:11", stock:88, price:"$15.21", origPrice:"", promoPrice:"促销价: $3.04", quality:"优质", qualityLevel:3 },
  { id:20, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240282372436585 6", msku:"商家 SKU: K918", sales:"已售出 2 件", salesViews:"浏览次数: 912", salesAmt:"销售额: $16.74", status:"在售", statusTime:"2026/05/27 18:33", stock:194, price:"$12.12", origPrice:"", promoPrice:"促销价: $2.42", quality:"优质", qualityLevel:3 },
  { id:21, img:null, name:"[VIKINGS Collection] Vintage Nautical Ancho...", idNo:"ID:173243814396253752", msku:"商家 SKU: K911", sales:"--", status:"在售", statusTime:"星期五 02:21", stock:165, price:"$16.13", origPrice:"", promoPrice:"", quality:"优质", qualityLevel:3 },
  { id:22, img:null, name:"Boho Elephant Leather Bracelet, Adjustable...", idNo:"ID:173243814063987528", msku:"商家 SKU: K918", sales:"--", status:"在售", statusTime:"星期五 02:19", stock:236, price:"$12.13", origPrice:"", promoPrice:"", quality:"优质", qualityLevel:3 },
  { id:23, img:null, name:"【US Local Warehouse Shipping / Dispatched...】", idNo:"ID:173240279735602796", msku:"商家组合", sales:"已售出 0 件", salesViews:"浏览次数: 537", salesAmt:"销售额: $0.00", status:"在售", statusTime:"星期四 09:55", stock:90, price:"$39.99", origPrice:"标价: $59.99", promoPrice:"促销价: $4.00", quality:"一般", qualityLevel:1 },
];

const INIT_ORDERS = [
  { id:"577407105502450545", date:"2026/05/26 18:38:16", customer:"odem275", customerName:"Odem275", items:"1 件商品", status:"已送达", logistics:"TikTok 物流", trackNo:"USPS, 9200190391695322114290", deadline:"送达截止日期: 2026/06/04", method:"标准运输", total:"$9.84" },
  { id:"577406619293094698", date:"2026/05/26 11:43:44", customer:"emori.butler", customerName:"Emori Butler", items:"1 件商品", status:"已送达", logistics:"TikTok 物流", trackNo:"USPS, 9200190391695322114450", deadline:"送达截止日期: 2026/06/04", method:"标准运输", total:"$9.51" },
  { id:"577406316074603157", date:"2026/05/26 06:45:52", customer:"rc21207", customerName:"Rc", items:"1 件商品", status:"已送达", logistics:"TikTok 物流", trackNo:"USPS, 9200190391695322062195", deadline:"送达截止日期: 2026/06/04", method:"标准运输", total:"$6.21" },
  { id:"577401992840254024", date:"2026/05/23 06:37:42", customer:"amia.jasmine", customerName:"Amia", items:"1 件商品", status:"已送达", logistics:"TikTok 物流", trackNo:"USPS, 9200190391695321965534", deadline:"送达截止日期: 2026/06/03", method:"标准运输", total:"$8.81" },
];

function EditField({ value, onChange, style={} }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(String(value));
  const display = typeof value==="number" ? (String(value).includes(".")?Number(value).toFixed(2):String(Math.round(value))) : String(value);
  if (editing) return (
    <span style={{display:"inline-flex",alignItems:"center",gap:2}}>
      <input value={val} autoFocus onChange={e=>setVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){onChange(!isNaN(val)&&val!==""?Number(val):val);setEditing(false);}if(e.key==="Escape")setEditing(false);}} style={{border:"1px solid #21c3bc",borderRadius:2,padding:"0 4px",fontSize:"inherit",fontWeight:"inherit",width:90,outline:"none",...style}}/>
      <button onClick={()=>{onChange(!isNaN(val)&&val!==""?Number(val):val);setEditing(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 5px",fontSize:11,cursor:"pointer"}}>✓</button>
    </span>
  );
  return <span onDoubleClick={()=>{setVal(display);setEditing(true);}} style={{cursor:"default",borderBottom:"none",...style}} title="双击编辑">{display}</span>;
}

const Icons = {
  home:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  products:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
  orders:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  logistics:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  ads:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  customer:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  affiliate:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  live:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>,
  growth:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>,
  apps:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><rect x="2" y="3" width="4" height="4"/><rect x="10" y="3" width="4" height="4"/><rect x="18" y="3" width="4" height="4"/><rect x="2" y="10" width="4" height="4"/><rect x="10" y="10" width="4" height="4"/><rect x="18" y="10" width="4" height="4"/><rect x="2" y="17" width="4" height="4"/><rect x="10" y="17" width="4" height="4"/><rect x="18" y="17" width="4" height="4"/></svg>,
  analytics:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  health:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
  compliance:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  finance:(a)=><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={a?"#21c3bc":"#666"} strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
};

function TikTokLogo() {
  return <svg width="26" height="26" viewBox="0 0 48 48" fill="none"><path d="M34.2 6.4c0 0 2.2 4.6 7.8 5.6v7.8c-2.8 0-5.4-0.8-7.8-2.2V32c0 8.8-7.2 16-16 16S2 40.8 2 32s7.2-16 16-16c0.8 0 1.6 0.1 2.4 0.2v8.1c-0.8-0.2-1.6-0.3-2.4-0.3-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8V6.4h8z" fill="white"/></svg>;
}

function ProductsPage() {
  const [tab, setTab] = useState("全部");
  const [shopProds, setShopProds] = useState(()=>loadProds()||INIT_SHOP_PRODUCTS);
  // Load images from IndexedDB on mount
  useEffect(()=>{
    const base = loadProds()||INIT_SHOP_PRODUCTS;
    loadProdsWithImages(base).then(prods=>setShopProds(prods));
  },[]);
  const [editIdx, setEditIdx] = useState(null);
  const [editBuf, setEditBuf] = useState({});
  const [showAdd, setShowAdd] = useState(false);
  const [saleCount, setSaleCount] = useState(()=>{ try{const s=localStorage.getItem('tts_sale_count');return s||'20';}catch{return '20';} });
  const [attentionCount, setAttentionCount] = useState(()=>{ try{const s=localStorage.getItem('tts_attention_count');return s||'20';}catch{return '20';} });
  const [editSale, setEditSale] = useState(false);
  const [editAttention, setEditAttention] = useState(false);
  const [newProd, setNewProd] = useState({name:"",idNo:"",msku:"",stock:"",price:"",status:"在售",quality:"优质",qualityLevel:3});
  const [newImg, setNewImg] = useState(null);
  const fileRefs = useRef({});
  const newImgRef = useRef();
  const tabs = ["全部","在售","审核中","需要关注","已下架","草稿","已删除"];

  const handleImgUpload = (id,file) => { const r=new FileReader(); r.onload=e=>setShopProds(ps=>{ const next=ps.map(p=>p.id===id?{...p,img:e.target.result}:p); saveProds(next); return next; }); r.readAsDataURL(file); };
  const handleNewImg = (file) => { const r=new FileReader(); r.onload=e=>setNewImg(e.target.result); r.readAsDataURL(file); };
  const saveEdit = () => { setShopProds(ps=>{ const next=ps.map((p,i)=>i===editIdx?{...p,...editBuf,stock:Number(editBuf.stock||p.stock)}:p); saveProds(next); return next; }); setEditIdx(null); };
  const deleteProd = (idx) => { if(window.confirm("确认删除该商品？")) setShopProds(ps=>{ const next=ps.filter((_,i)=>i!==idx); saveProds(next); return next; }); };
  const addProd = () => {
    if(!newProd.name.trim()) return;
    setShopProds(ps=>{ const next=[...ps,{id:Date.now(),img:newImg,name:newProd.name,idNo:newProd.idNo||"ID:"+Date.now(),msku:newProd.msku||"商家 SKU: NEW",sales:"--",status:newProd.status,statusTime:new Date().toLocaleDateString("zh-CN"),stock:Number(newProd.stock)||0,price:newProd.price||"$0.00",origPrice:"",promoPrice:"",quality:newProd.quality,qualityLevel:newProd.qualityLevel}]; saveProds(next); return next; });
    setNewProd({name:"",idNo:"",msku:"",stock:"",price:"",status:"在售",quality:"优质",qualityLevel:3}); setNewImg(null); setShowAdd(false);
  };
  const displayProds = tab==="全部"?shopProds:shopProds.filter(p=>p.status===tab);

  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>

      <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
        <div style={{padding:"16px 20px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <h2 style={{margin:0,fontSize:20,fontWeight:600,color:"#111"}}>商品管理</h2>
            <div style={{display:"flex",gap:8}}>
              <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:3,padding:"7px 14px",fontSize:13,cursor:"pointer",color:"#333"}}>媒体中心</button>
              <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:3,padding:"7px 14px",fontSize:13,cursor:"pointer",color:"#333"}}>组合发品</button>
              <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:3,padding:"7px 14px",fontSize:13,cursor:"pointer",color:"#333"}}>批量操作 ▾</button>
              <button onClick={()=>setShowAdd(true)} style={{background:"#21c3bc",border:"none",borderRadius:3,padding:"7px 16px",fontSize:13,cursor:"pointer",color:"#fff",fontWeight:500}}>+ 添加商品</button>
            </div>
          </div>
          <div style={{background:"#fff",borderRadius:4,padding:"14px 20px",marginBottom:12,display:"grid",gridTemplateColumns:"1fr 1fr",gap:20}}>
            <div><div style={{fontWeight:600,fontSize:13,color:"#111",marginBottom:3}}>加入 FBT，助力销量增长</div><div style={{fontSize:12,color:"#888",marginBottom:8}}>将曝光提升 30%，促进销量增长</div><div style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>加入 FBT &gt;</div></div>
            <div style={{borderLeft:"1px solid #f0f0f0",paddingLeft:20}}><div style={{fontWeight:600,fontSize:13,color:"#111",marginBottom:3}}>提升发品质量，提高转化率和销售额</div><div style={{fontSize:12,color:"#888",marginBottom:8}}>3 个发品待优化</div><div style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>优化发品 &gt;</div></div>
          </div>
          {showAdd && (
            <div style={{background:"#fff",borderRadius:4,padding:16,marginBottom:12,border:"1px dashed #21c3bc"}}>
              <div style={{fontWeight:600,fontSize:14,marginBottom:12,color:"#111"}}>添加新商品</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:10}}>
                {[{label:"商品名称*",key:"name",ph:"输入商品名称"},{label:"商品ID",key:"idNo",ph:"如: ID:173243..."},{label:"商家SKU",key:"msku",ph:"如: 商家 SKU: K001"},{label:"库存",key:"stock",ph:"如: 100"},{label:"价格",key:"price",ph:"如: $19.99"}].map(f=>(
                  <div key={f.key}><div style={{fontSize:12,color:"#666",marginBottom:4}}>{f.label}</div><input value={newProd[f.key]} onChange={e=>setNewProd(p=>({...p,[f.key]:e.target.value}))} placeholder={f.ph} style={{width:"100%",border:"1px solid #ddd",borderRadius:3,padding:"6px 10px",fontSize:13,outline:"none",boxSizing:"border-box"}}/></div>
                ))}
                <div><div style={{fontSize:12,color:"#666",marginBottom:4}}>状态</div><select value={newProd.status} onChange={e=>setNewProd(p=>({...p,status:e.target.value}))} style={{width:"100%",border:"1px solid #ddd",borderRadius:3,padding:"6px 10px",fontSize:13,outline:"none"}}>{["在售","审核中","已下架","草稿"].map(s=><option key={s}>{s}</option>)}</select></div>
                <div><div style={{fontSize:12,color:"#666",marginBottom:4}}>发品质量</div><select value={newProd.quality} onChange={e=>setNewProd(p=>({...p,quality:e.target.value,qualityLevel:e.target.value==="优质"?3:e.target.value==="一般"?2:1}))} style={{width:"100%",border:"1px solid #ddd",borderRadius:3,padding:"6px 10px",fontSize:13,outline:"none"}}>{["优质","一般","低质"].map(s=><option key={s}>{s}</option>)}</select></div>
              </div>
              <div style={{marginBottom:12}}><div style={{fontSize:12,color:"#666",marginBottom:4}}>商品图片</div><div onClick={()=>newImgRef.current?.click()} style={{width:80,height:80,border:"1px dashed #ccc",borderRadius:4,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",overflow:"hidden",background:"#fafafa"}}>{newImg?<img src={newImg} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg><span style={{fontSize:10,color:"#bbb",marginTop:3}}>上传图片</span></>}</div><input ref={newImgRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleNewImg(e.target.files[0])}/></div>
              <div style={{display:"flex",gap:8}}><button onClick={addProd} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"7px 20px",fontSize:13,cursor:"pointer",fontWeight:500}}>确认添加</button><button onClick={()=>{setShowAdd(false);setNewImg(null);}} style={{background:"#fff",color:"#666",border:"1px solid #ddd",borderRadius:3,padding:"7px 14px",fontSize:13,cursor:"pointer"}}>取消</button></div>
            </div>
          )}
          <div style={{background:"#fff",borderRadius:4,overflow:"hidden"}}>
            <div style={{display:"flex",alignItems:"center",borderBottom:"1px solid #f0f0f0",padding:"0 16px"}}>
              {tabs.map(t=>(
                <div key={t} onClick={()=>setTab(t)} style={{padding:"11px 14px",fontSize:13,cursor:"pointer",color:tab===t?"#21c3bc":"#555",borderBottom:tab===t?"2px solid #21c3bc":"2px solid transparent",fontWeight:tab===t?500:400,whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:4}}>
                  {t}
                  {t==="在售" && (
                    editSale
                      ? <input autoFocus value={saleCount} onChange={e=>setSaleCount(e.target.value)}
                          onBlur={()=>{setEditSale(false);localStorage.setItem('tts_sale_count',saleCount);}}
                          onKeyDown={e=>{if(e.key==='Enter'){setEditSale(false);localStorage.setItem('tts_sale_count',saleCount);}}}
                          onClick={e=>e.stopPropagation()}
                          style={{width:36,border:"1px solid #21c3bc",borderRadius:10,padding:"0 5px",fontSize:11,outline:"none",textAlign:"center"}}/>
                      : <span onClick={e=>{e.stopPropagation();setEditSale(true);}} style={{background:"#f0f0f0",borderRadius:10,padding:"0 6px",fontSize:11,color:"#666",cursor:"text"}} title="双击编辑">{saleCount}</span>
                  )}
                  {t==="需要关注" && (<>
                    {editAttention
                      ? <input autoFocus value={attentionCount} onChange={e=>setAttentionCount(e.target.value)}
                          onBlur={()=>{setEditAttention(false);localStorage.setItem('tts_attention_count',attentionCount);}}
                          onKeyDown={e=>{if(e.key==='Enter'){setEditAttention(false);localStorage.setItem('tts_attention_count',attentionCount);}}}
                          onClick={e=>e.stopPropagation()}
                          style={{width:36,border:"1px solid #21c3bc",borderRadius:10,padding:"0 5px",fontSize:11,outline:"none",textAlign:"center"}}/>
                      : <span onClick={e=>{e.stopPropagation();setEditAttention(true);}} style={{background:"#f0f0f0",borderRadius:10,padding:"0 6px",fontSize:11,color:"#666",cursor:"text"}} title="双击编辑">{attentionCount}</span>
                    }
                    <span style={{width:6,height:6,borderRadius:"50%",background:"#ff4d4f",display:"inline-block"}}/>
                  </>)}
                </div>
              ))}
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 16px",borderBottom:"1px solid #f5f5f5"}}>
              <div style={{display:"flex",alignItems:"center",border:"1px solid #ddd",borderRadius:3,padding:"5px 10px",gap:6,width:220}}><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg><input placeholder="商品名称、ID 或 SKU" style={{border:"none",outline:"none",fontSize:13,width:"100%",color:"#333"}}/></div>
              <div style={{border:"1px solid #ddd",borderRadius:3,padding:"5px 12px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>关目 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
              <div style={{border:"1px solid #ddd",borderRadius:3,padding:"5px 12px",fontSize:13,color:"#555",cursor:"pointer"}}>售罄 0</div>
              <div style={{border:"1px solid #ddd",borderRadius:3,padding:"5px 12px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:5}}><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="14" y2="12"/><line x1="4" y1="18" x2="8" y2="18"/></svg>筛选条件</div>
              <div style={{marginLeft:"auto",border:"1px solid #ddd",borderRadius:3,padding:"5px 12px",fontSize:13,color:"#555",cursor:"pointer"}}>↕ 排序依据</div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"32px 2.8fr 1fr 1fr 0.7fr 0.9fr 1fr 90px",alignItems:"center",padding:"9px 16px",background:"#fafafa",borderBottom:"1px solid #f0f0f0",fontSize:12,color:"#888",fontWeight:500}}>
              <input type="checkbox"/><span>商品</span><span>表现</span><span>状态</span><span>库存</span><span>价格</span><span>发品质量</span><span>操作</span>
            </div>
            {displayProds.map((p,idx)=>{
              const isEdit=editIdx===idx;
              const qColor=p.qualityLevel===3?"#52c41a":p.qualityLevel===2?"#faad14":"#ff4d4f";
              return (
                <div key={p.id} style={{display:"grid",gridTemplateColumns:"32px 2.8fr 1fr 1fr 0.7fr 0.9fr 1fr 90px",alignItems:"center",padding:"13px 16px",borderBottom:"1px solid #f5f5f5",background:isEdit?"#f0fffe":"#fff"}}>
                  <input type="checkbox"/>
                  <div style={{display:"flex",alignItems:"flex-start",gap:10,paddingRight:10}}>
                    <div style={{width:48,height:48,background:"#f5f5f5",borderRadius:4,flexShrink:0,overflow:"hidden",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}} onClick={()=>fileRefs.current[p.id]?.click()}>
                      {p.img?<img src={p.img} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>}
                      <input ref={el=>fileRefs.current[p.id]=el} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleImgUpload(p.id,e.target.files[0])}/>
                    </div>
                    <div style={{minWidth:0}}>
                      {isEdit?<input value={editBuf.name||""} onChange={e=>setEditBuf(b=>({...b,name:e.target.value}))} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:13,width:"100%",outline:"none",boxSizing:"border-box",marginBottom:2}}/>:<div style={{fontSize:13,color:"#111",marginBottom:2,lineHeight:1.4}}>{p.name}</div>}
                      <div style={{fontSize:11,color:"#bbb"}}>{p.idNo}</div><div style={{fontSize:11,color:"#bbb"}}>{p.msku}</div>
                    </div>
                  </div>
                  <div style={{fontSize:12}}>
                    {isEdit ? (
                      <div style={{display:"flex",flexDirection:"column",gap:4}}>
                        <input value={editBuf.sales||""} onChange={e=>setEditBuf(b=>({...b,sales:e.target.value}))} placeholder="如: 已售出 5 件" style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:11,width:110,outline:"none"}}/>
                        <input value={editBuf.salesViews||""} onChange={e=>setEditBuf(b=>({...b,salesViews:e.target.value}))} placeholder="如: 浏览次数: 537" style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:11,width:110,outline:"none"}}/>
                        <input value={editBuf.salesAmt||""} onChange={e=>setEditBuf(b=>({...b,salesAmt:e.target.value}))} placeholder="如: 销售额: $0.00" style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:11,width:110,outline:"none"}}/>
                      </div>
                    ) : p.sales==="--" ? <span style={{color:"#bbb"}}>--</span> : (
                      <div>
                        <div style={{color:"#333"}}>{p.sales}</div>
                        {p.salesViews&&<div style={{color:"#bbb",fontSize:11,marginTop:1}}>{p.salesViews}</div>}
                        {p.salesAmt&&<div style={{color:"#bbb",fontSize:11}}>{p.salesAmt}</div>}
                        <div style={{color:"#21c3bc",fontSize:11,marginTop:2,cursor:"pointer"}}>分析</div>
                      </div>
                    )}
                  </div>
                  <div><div style={{display:"flex",alignItems:"center",gap:4,fontSize:13,color:"#333",marginBottom:2}}><div style={{width:6,height:6,borderRadius:"50%",background:"#52c41a",flexShrink:0}}/>{isEdit?<select value={editBuf.status||p.status} onChange={e=>setEditBuf(b=>({...b,status:e.target.value}))} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px",fontSize:12,outline:"none"}}>{["在售","审核中","已下架","草稿"].map(s=><option key={s}>{s}</option>)}</select>:p.status}</div><div style={{fontSize:11,color:"#bbb"}}>{p.statusTime}</div></div>
                  <div style={{fontSize:13,color:"#333"}}>{isEdit?<input type="number" value={editBuf.stock??p.stock} onChange={e=>setEditBuf(b=>({...b,stock:e.target.value}))} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:13,width:65,outline:"none"}}/>:p.stock}</div>
                  <div>{isEdit?<input value={editBuf.price??p.price} onChange={e=>setEditBuf(b=>({...b,price:e.target.value}))} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:13,width:75,outline:"none"}}/>:<div><div style={{fontSize:13,color:"#333"}}>{p.price}</div>{p.origPrice&&<div style={{fontSize:11,color:"#bbb",marginTop:1}}>{p.origPrice}</div>}{p.promoPrice&&<div style={{fontSize:11,color:"#bbb"}}>{p.promoPrice}</div>}</div>}</div>
                  <div><div style={{fontSize:13,color:"#333",marginBottom:4}}>{p.quality}</div><div style={{display:"flex",gap:2}}>{[1,2,3].map(n=><div key={n} style={{width:26,height:3,borderRadius:2,background:n<=p.qualityLevel?qColor:"#e8e8e8"}}/>)}</div>{p.qualityLevel<3&&<div style={{fontSize:11,color:"#faad14",marginTop:3}}>可能影响商品曝光次数</div>}</div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    {isEdit?<><button onClick={saveEdit} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"4px 10px",fontSize:12,cursor:"pointer"}}>保存</button><button onClick={()=>setEditIdx(null)} style={{background:"#f0f0f0",color:"#666",border:"none",borderRadius:3,padding:"4px 8px",fontSize:12,cursor:"pointer"}}>取消</button></>:<>
                      <button onClick={()=>{setEditIdx(idx);setEditBuf({name:p.name,status:p.status,stock:p.stock,price:p.price,sales:p.sales,salesViews:p.salesViews||'',salesAmt:p.salesAmt||''});}} style={{background:"none",border:"none",cursor:"pointer",padding:4,color:"#555"}} title="编辑"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></button>
                      <button onClick={()=>{if(window.confirm("确认删除该商品？"))deleteProd(idx);}} style={{background:"none",border:"none",cursor:"pointer",padding:4}} title="删除"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ff4d4f" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg></button>
                      <button style={{background:"none",border:"none",cursor:"pointer",padding:4,color:"#555"}}><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2"><circle cx="12" cy="5" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="12" cy="19" r="1"/></svg></button>
                    </>}
                  </div>
                </div>
              );
            })}
            <div style={{padding:"10px 16px",fontSize:12,color:"#888",borderTop:"1px solid #f0f0f0"}}>{displayProds.length} 个 SKU</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function OrdersPage() {
  const [tab, setTab] = useState("全部");
  const [orders, setOrders] = useState(()=>loadOrders()||INIT_ORDERS);
  const [subNav, setSubNav] = useState("管理订单");
  const [showBanner, setShowBanner] = useState(true);
  const tabs = ["全部","待支付","待发货","已发货","已完成","已取消"];
  const subNavItems = ["管理订单","批量发货","管理取消申请","管理退货","履约表现","包邮","退货设置"];
  const deleteOrder = (idx) => { if(window.confirm("确认删除该订单？")) setOrders(os=>{ const next=os.filter((_,i)=>i!==idx); saveOrders(next); return next; }); };

  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>
      <div style={{width:140,background:"#fff",borderRight:"1px solid #ebebeb",flexShrink:0,paddingTop:4,overflowY:"auto"}}>
        {subNavItems.map(n=><div key={n} onClick={()=>setSubNav(n)} style={{padding:"9px 16px",fontSize:13,cursor:"pointer",color:subNav===n?"#21c3bc":"#333",background:subNav===n?"#f0fffe":"transparent",borderLeft:subNav===n?"3px solid #21c3bc":"3px solid transparent",fontWeight:subNav===n?500:400}}>{n}</div>)}
      </div>
      <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
        <div style={{padding:"16px 20px"}}>
          {showBanner&&<div style={{background:"#fffbe6",border:"1px solid #ffe58f",borderRadius:4,padding:"10px 14px",marginBottom:14,display:"flex",alignItems:"center",justifyContent:"space-between"}}><span style={{fontSize:13,color:"#614700"}}>⚠️ 今天你有 0/5 个订单。计数将于次日 00:00:00 重置。</span><span onClick={()=>setShowBanner(false)} style={{cursor:"pointer",color:"#999",fontSize:16,lineHeight:1}}>×</span></div>}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
            <h2 style={{margin:0,fontSize:20,fontWeight:600,color:"#111"}}>管理订单</h2>
            <div style={{display:"flex",gap:8}}>
              <div style={{border:"1px solid #ddd",borderRadius:3,padding:"6px 12px",fontSize:12,color:"#555",display:"flex",alignItems:"center",gap:6,cursor:"pointer"}}><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>搜索订单 ID/商品 ID/商品名称/SKU ID/物流单号</div>
              <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:3,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#333"}}>物流面单</button>
              <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:3,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#333"}}>↑ 上传</button>
            </div>
          </div>
          <div style={{background:"#fff",borderRadius:4,padding:"16px 20px",marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <div style={{display:"flex",alignItems:"center",gap:14}}>
              <div style={{background:"#21c3bc",color:"#fff",borderRadius:4,padding:"3px 8px",fontSize:12,fontWeight:700}}>FBT</div>
              <div><div style={{fontWeight:600,fontSize:13,color:"#111",marginBottom:3}}>将商品运送至 FBT 仓库，解锁 FBT 全部权益</div><div style={{fontSize:12,color:"#888"}}>创建首笔入库单并将库单存运送至 FBT 仓库，即可获得额外 30% 曝光度和包邮三日达服务，同时享受物流处罚豁免。</div></div>
            </div>
            <button style={{background:"#21c3bc",border:"none",borderRadius:3,padding:"7px 14px",fontSize:13,cursor:"pointer",color:"#fff",flexShrink:0,marginLeft:16}}>开始体验</button>
          </div>
          <div style={{background:"#fff",borderRadius:4,padding:"16px 20px",marginBottom:12}}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:14}}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg><span style={{fontWeight:600,fontSize:14,color:"#111"}}>待办事项</span></div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:0}}>
              {["24 小时内发货","24 小时内自动取消","备货超时","已申请取消","已申请退货/退款"].map((label,i)=>(
                <div key={label} style={{paddingRight:i<4?20:0,paddingLeft:i>0?20:0,borderRight:i<4?"1px solid #f0f0f0":"none"}}>
                  <div style={{fontSize:12,color:"#888",marginBottom:8}}>{label}</div>
                  <div style={{fontSize:22,fontWeight:700,color:"#111"}}>0</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{background:"#fff",borderRadius:4,overflow:"hidden"}}>
            <div style={{display:"flex",alignItems:"center",borderBottom:"1px solid #f0f0f0",padding:"0 16px"}}>
              {tabs.map(t=><div key={t} onClick={()=>setTab(t)} style={{padding:"11px 14px",fontSize:13,cursor:"pointer",color:tab===t?"#21c3bc":"#555",borderBottom:tab===t?"2px solid #21c3bc":"2px solid transparent",fontWeight:tab===t?500:400,whiteSpace:"nowrap"}}>{t}</div>)}
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8,padding:"10px 16px",borderBottom:"1px solid #f5f5f5"}}>
              <div style={{border:"1px solid #ddd",borderRadius:3,padding:"5px 12px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:5}}><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2"><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="12" x2="14" y2="12"/><line x1="4" y1="18" x2="8" y2="18"/></svg>筛选</div>
              <span style={{fontSize:13,color:"#888"}}>找到 {(()=>{
                try{const d=JSON.parse(localStorage.getItem('tts_data_v1')||'{}');return d.orders||orders.length;}catch{return orders.length;}
              })()} 个订单</span>
              <div style={{marginLeft:"auto",display:"flex",gap:8}}><button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"5px 10px",cursor:"pointer"}}>⟳</button><button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"5px 10px",cursor:"pointer"}}>↕</button><button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"5px 10px",cursor:"pointer"}}>↓</button></div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"32px 2fr 1fr 1fr 1fr 1.5fr 1fr 1fr 80px",alignItems:"center",padding:"9px 16px",background:"#fafafa",borderBottom:"1px solid #f0f0f0",fontSize:12,color:"#888",fontWeight:500}}>
              <input type="checkbox"/><span>订单</span><span>客户</span><span>商品</span><span>订单状态</span><span>物流方式</span><span>物流选项</span><span>合计</span><span>操作</span>
            </div>
            {orders.map((o,idx)=>(
              <div key={o.id} style={{display:"grid",gridTemplateColumns:"32px 2fr 1fr 1fr 1fr 1.5fr 1fr 1fr 80px",alignItems:"center",padding:"13px 16px",borderBottom:"1px solid #f5f5f5"}}>
                <input type="checkbox"/>
                <div><div style={{fontSize:13,color:"#21c3bc",cursor:"pointer",marginBottom:2}}>{o.id}</div><div style={{fontSize:11,color:"#bbb"}}>{o.date}</div></div>
                <div><div style={{fontSize:13,color:"#333"}}>{o.customer}</div><div style={{fontSize:11,color:"#bbb"}}>{o.customerName}</div></div>
                <div style={{fontSize:13,color:"#333"}}>{o.items}</div>
                <div><span style={{fontSize:13,color:o.status==="待发货"?"#fa8c16":o.status==="已送达"?"#52c41a":"#21c3bc",fontWeight:500}}>{o.status}</span></div>
                <div style={{fontSize:13,color:"#333"}}>{o.logistics}</div>
                <div><div style={{fontSize:12,color:"#555"}}>{o.method}</div><div style={{fontSize:11,color:"#bbb",marginTop:2,lineHeight:1.5}}>{o.trackNo}</div><div style={{fontSize:11,color:"#bbb"}}>{o.deadline}</div></div>
                <div style={{fontSize:13,fontWeight:600,color:"#111"}}>{o.total}</div>
                <div style={{display:"flex",gap:4}}>
                  <button style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"4px 8px",fontSize:11,cursor:"pointer",whiteSpace:"nowrap"}}>查看物流</button>
                  <button onClick={()=>deleteOrder(idx)} style={{background:"none",border:"none",cursor:"pointer",padding:4}} title="删除"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ff4d4f" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg></button>
                </div>
              </div>
            ))}
            <div style={{padding:"10px 16px",fontSize:12,color:"#888",borderTop:"1px solid #f0f0f0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>显示过去 12 个月的订单</span>
              <div style={{display:"flex",alignItems:"center",gap:8,fontSize:13}}><button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"3px 8px",cursor:"pointer"}}>‹</button><span style={{background:"#21c3bc",color:"#fff",borderRadius:3,padding:"3px 8px"}}>1</span><button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"3px 8px",cursor:"pointer"}}>›</button><span style={{color:"#888"}}>20/Page ▾</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const NAV_MID = [{id:"ads",label:"广告营销"},{id:"customer",label:"客户"},{id:"affiliate",label:"联盟"},{id:"live",label:"直播和视频"},{id:"growth",label:"成长中心"},{id:"apps",label:"应用和服务商"}];
const NAV_BOT = [{id:"analytics",label:"数据分析"},{id:"health",label:"账号健康"},{id:"compliance",label:"合规中心"},{id:"finance",label:"财务"}];
const initProducts = [{id:1,name:"party woman jewelry",img:null,tags:[]},{id:2,name:"high heat resistant",img:null,tags:["TikTok 热门商品","高热缺货"]},{id:3,name:"elegant jewelry bracelet",img:null,tags:[]},{id:4,name:"holiday present",img:null,tags:["TikTok 热门商品"]}];

function SimpleNavItem({id,label,page,setPage,hasChildren,expanded,onToggle}) {
  const a=page===id||(id==="products"&&page==="products")||(id==="orders"&&page==="orders");
  return <div onClick={()=>{if(hasChildren)onToggle();else setPage(id);}} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"9px 16px 9px 18px",cursor:"pointer",fontSize:13,color:a?"#21c3bc":"#333",background:a?"#f0fffe":"transparent",borderLeft:a?"3px solid #21c3bc":"3px solid transparent",fontWeight:a?500:400}}>
    <div style={{display:"flex",alignItems:"center",gap:8}}>{Icons[id]?.(a)}<span>{label}</span></div>
    {hasChildren&&<svg width="10" height="6" viewBox="0 0 10 6" fill={a?"#21c3bc":"#aaa"} style={{transform:expanded?"rotate(180deg)":"none",transition:"0.2s"}}><path d="M0 0l5 6 5-6z"/></svg>}
  </div>;
}






// ── 保证金页面 ────────────────────────────────────────────────────────────────
function DepositPage() {
  const [balance, setBalance] = useState("1,500.00");
  const [total, setTotal] = useState("1,500.00");
  const [editBal, setEditBal] = useState(false);
  const [editTotal, setEditTotal] = useState(false);
  const [balVal, setBalVal] = useState("1,500.00");
  const [totalVal, setTotalVal] = useState("1,500.00");
  const [activeTab, setActiveTab] = useState("充值/提现");

  return (
    <div style={{padding:"20px 24px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <h2 style={{margin:0,fontSize:20,fontWeight:600,color:"#111"}}>保证金</h2>
        <div style={{display:"flex",gap:8}}>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"7px 16px",fontSize:13,cursor:"pointer",color:"#333"}}>提现</button>
          <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"7px 16px",fontSize:13,cursor:"pointer",color:"#fff",fontWeight:500}}>余额充值</button>
        </div>
      </div>
      {/* 余额卡片 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px",marginBottom:16,display:"grid",gridTemplateColumns:"1fr 1fr",gap:0}}>
        <div style={{paddingRight:24,borderRight:"1px solid #f0f0f0"}}>
          <div style={{display:"flex",alignItems:"center",gap:4,fontSize:12,color:"#888",marginBottom:8}}>
            余额
            <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span>
          </div>
          <div style={{fontSize:26,fontWeight:700,color:"#111"}}>
            ${editBal
              ? <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                  <input autoFocus value={balVal} onChange={e=>setBalVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setBalance(balVal);setEditBal(false);}}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"0 6px",fontSize:22,fontWeight:700,width:120,outline:"none"}}/>
                  <button onClick={()=>{setBalance(balVal);setEditBal(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"3px 8px",fontSize:12,cursor:"pointer"}}>✓</button>
                </span>
              : <span onDoubleClick={()=>{setBalVal(balance);setEditBal(true);}} style={{cursor:"default",borderBottom:"none"}}>{balance}</span>
            }
          </div>
        </div>
        <div style={{paddingLeft:24}}>
          <div style={{fontSize:12,color:"#888",marginBottom:8}}>应付总金额</div>
          <div style={{fontSize:26,fontWeight:700,color:"#111",marginBottom:6}}>
            ${editTotal
              ? <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                  <input autoFocus value={totalVal} onChange={e=>setTotalVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setTotal(totalVal);setEditTotal(false);}}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"0 6px",fontSize:22,fontWeight:700,width:120,outline:"none"}}/>
                  <button onClick={()=>{setTotal(totalVal);setEditTotal(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"3px 8px",fontSize:12,cursor:"pointer"}}>✓</button>
                </span>
              : <span onDoubleClick={()=>{setTotalVal(total);setEditTotal(true);}} style={{cursor:"default",borderBottom:"none"}}>{total}</span>
            }
          </div>
          <div style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>保证金收取标准</div>
        </div>
      </div>
      {/* Tab */}
      <div style={{background:"#fff",borderRadius:6,overflow:"hidden"}}>
        <div style={{display:"flex",borderBottom:"1px solid #f0f0f0",padding:"0 16px"}}>
          {["充值/提现","冻结/扣款"].map(t=>(
            <div key={t} onClick={()=>setActiveTab(t)} style={{padding:"12px 16px",fontSize:13,cursor:"pointer",color:activeTab===t?"#21c3bc":"#555",borderBottom:activeTab===t?"2px solid #21c3bc":"2px solid transparent",fontWeight:activeTab===t?500:400}}>{t}</div>
          ))}
        </div>
        <div style={{padding:"16px 20px"}}>
          {/* 筛选 */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:12,marginBottom:12}}>
            <div>
              <div style={{fontSize:12,color:"#888",marginBottom:6}}>订单 ID</div>
              <input placeholder="请输入" style={{width:"100%",border:"1px solid #ddd",borderRadius:4,padding:"7px 10px",fontSize:13,outline:"none",boxSizing:"border-box"}}/>
            </div>
            <div>
              <div style={{fontSize:12,color:"#888",marginBottom:6}}>订单类型</div>
              <div style={{border:"1px solid #ddd",borderRadius:4,padding:"7px 10px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>全部 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
            </div>
            <div>
              <div style={{fontSize:12,color:"#888",marginBottom:6}}>订单状态</div>
              <div style={{border:"1px solid #ddd",borderRadius:4,padding:"7px 10px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",justifyContent:"space-between",alignItems:"center"}}>全部 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
            </div>
          </div>
          <div style={{marginBottom:16}}>
            <div style={{fontSize:12,color:"#888",marginBottom:6}}>创建时间</div>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              <div style={{flex:1,border:"1px solid #ddd",borderRadius:4,padding:"7px 10px",fontSize:13,color:"#bbb",display:"flex",justifyContent:"space-between"}}>开始日期 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></div>
              <span style={{color:"#bbb"}}>-</span>
              <div style={{flex:1,border:"1px solid #ddd",borderRadius:4,padding:"7px 10px",fontSize:13,color:"#bbb",display:"flex",justifyContent:"space-between"}}>结束日期 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg></div>
              <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"7px 20px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500}}>搜索</button>
              <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"7px 16px",color:"#555",fontSize:13,cursor:"pointer"}}>重置</button>
            </div>
          </div>
          {/* 结果 */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <span style={{fontSize:13,color:"#555"}}><strong>1</strong> 项目</span>
            <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"5px 14px",fontSize:13,cursor:"pointer",color:"#555"}}>导出</button>
          </div>
          <div style={{border:"1px solid #f0f0f0",borderRadius:6,overflow:"hidden"}}>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1.5fr 1.5fr 1fr 1fr 1fr 1fr",padding:"10px 16px",background:"#fafafa",fontSize:12,color:"#888",fontWeight:500,borderBottom:"1px solid #f0f0f0"}}>
              <span>订单 ID</span><span>创建时间</span><span>更新时间</span><span>订单类型</span><span>充值金额</span><span>付款金额</span><span>费用</span>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1.5fr 1.5fr 1fr 1fr 1fr 1fr",padding:"14px 16px",fontSize:13,color:"#333",alignItems:"center",borderBottom:"1px solid #f5f5f5"}}>
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <span>865550794811300664 8</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
              </div>
              <span>2026/04/24 01:20:28</span>
              <span>2026/04/24 01:21:53</span>
              <span>充值</span>
              <span>$1,500.00</span>
              <span>¥10,411.16</span>
              <span>¥103.06</span>
            </div>
          </div>
          {/* 分页 */}
          <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:8,marginTop:12}}>
            <button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"3px 8px",cursor:"pointer"}}>‹</button>
            <span style={{background:"#21c3bc",color:"#fff",borderRadius:3,padding:"3px 8px",fontSize:13}}>1</span>
            <button style={{background:"none",border:"1px solid #ddd",borderRadius:3,padding:"3px 8px",cursor:"pointer"}}>›</button>
            <span style={{color:"#888",fontSize:13}}>20 /页 ▾</span>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── 钱包页面 ──────────────────────────────────────────────────────────────────
function WalletPage() {
  const [usdAmount, setUsdAmount] = useState("1.00");
  const [cnyAmount, setCnyAmount] = useState("6.75");
  const [timer, setTimer] = useState(46);
  const [activeTab, setActiveTab] = useState("全部");
  const [currencies, setCurrencies] = useState([
    {k:"JPY",v:"0"},{k:"GBP",v:"0.00"},{k:"USD",v:"0.00"},{k:"EUR",v:"0.00"},{k:"CNH",v:"0.00"}
  ]);
  const [totalUsd, setTotalUsd] = useState("0.00");
  const [editTotal, setEditTotal] = useState(false);
  const [totalVal, setTotalVal] = useState("0.00");
  const [editingCurrency, setEditingCurrency] = useState(null);
  const [currencyVal, setCurrencyVal] = useState("");

  // 汇率折线图数据点
  const points = [
    {x:70,y:50},{x:110,y:45},{x:150,y:60},{x:190,y:58},{x:230,y:70},{x:270,y:65},
    {x:310,y:68},{x:350,y:72},{x:390,y:75},{x:430,y:70},{x:470,y:80},{x:510,y:78},
    {x:550,y:82},{x:590,y:80},{x:630,y:78},{x:670,y:85},{x:710,y:90},{x:750,y:88}
  ];
  const polyline = points.map(p=>`${p.x},${p.y}`).join(" ");

  return (
    <div style={{padding:"20px 24px"}}>
      {/* 总额 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontWeight:600,fontSize:15,color:"#111"}}>总额</div>
          <div style={{display:"flex",gap:8}}>
            <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#555"}}>自动提现设置</button>
            <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"6px 16px",fontSize:13,cursor:"pointer",color:"#fff",fontWeight:500}}>付款</button>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"baseline",gap:10,marginBottom:4}}>
          {editTotal
            ? <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                <input autoFocus value={totalVal} onChange={e=>setTotalVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setTotalUsd(totalVal);setEditTotal(false);}if(e.key==="Escape")setEditTotal(false);}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"0 6px",fontSize:24,fontWeight:700,color:"#21c3bc",width:100,outline:"none"}}/>
                <button onClick={()=>{setTotalUsd(totalVal);setEditTotal(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"3px 8px",fontSize:12,cursor:"pointer"}}>✓</button>
              </span>
            : <span onDoubleClick={()=>{setTotalVal(totalUsd);setEditTotal(true);}} style={{fontSize:28,fontWeight:700,color:"#21c3bc",cursor:"pointer",borderBottom:"none"}} title="双击编辑">{totalUsd}</span>
          }
          <div style={{border:"1px solid #ddd",borderRadius:4,padding:"3px 10px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>USD <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
        </div>
        <div style={{fontSize:12,color:"#888",marginBottom:16}}>以 USD 预估，汇率更新时间: 2026-06-14 03:30:59 当前汇率仅供参考</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:12}}>
          {currencies.map((c,i)=>(
            <div key={c.k} style={{border:"1px solid #f0f0f0",borderRadius:4,padding:"10px 14px"}}>
              <div style={{fontSize:12,color:"#888",marginBottom:4}}>{c.k}</div>
              {editingCurrency===i
                ? <span style={{display:"inline-flex",alignItems:"center",gap:2}}>
                    <input autoFocus value={currencyVal} onChange={e=>setCurrencyVal(e.target.value)}
                      onKeyDown={e=>{
                        if(e.key==="Enter"){setCurrencies(cs=>cs.map((cc,ii)=>ii===i?{...cc,v:currencyVal}:cc));setEditingCurrency(null);}
                        if(e.key==="Escape")setEditingCurrency(null);
                      }}
                      style={{border:"1px solid #21c3bc",borderRadius:2,padding:"0 4px",fontSize:14,fontWeight:600,width:60,outline:"none"}}/>
                    <button onClick={()=>{setCurrencies(cs=>cs.map((cc,ii)=>ii===i?{...cc,v:currencyVal}:cc));setEditingCurrency(null);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 4px",fontSize:10,cursor:"pointer"}}>✓</button>
                  </span>
                : <div onDoubleClick={()=>{setCurrencyVal(c.v);setEditingCurrency(i);}} style={{fontSize:15,fontWeight:600,color:"#111",cursor:"pointer",borderBottom:"none"}} title="双击编辑">{c.v}</div>
              }
            </div>
          ))}
        </div>
      </div>

      {/* 外汇兑换 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:6}}>
          <div style={{fontWeight:600,fontSize:15,color:"#111"}}>外汇兑换</div>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"5px 12px",fontSize:12,cursor:"pointer",color:"#555"}}>兑换记录</button>
        </div>
        <div style={{fontSize:12,color:"#888",marginBottom:16}}>
          通过下方按钮发起「实时兑换」或「指定汇率兑换」，或在右侧「汇率提醒」设置汇率监测，更多说明请查看 <span style={{color:"#21c3bc",cursor:"pointer"}}>功能指南</span>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:24}}>
          {/* 兑换表单 */}
          <div>
            <div style={{fontSize:12,color:"#888",marginBottom:6}}>卖出</div>
            <div style={{border:"1px solid #ddd",borderRadius:4,padding:"8px 12px",display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
              <div style={{display:"flex",alignItems:"center",gap:4,fontSize:13,color:"#333",cursor:"pointer"}}>USD <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
              <input value={usdAmount} onChange={e=>setUsdAmount(e.target.value)} style={{flex:1,border:"none",outline:"none",fontSize:15,fontWeight:500,textAlign:"right"}}/>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:4,fontSize:12,color:"#888",marginBottom:6}}>
              买入
              <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span>
            </div>
            <div style={{border:"1px solid #ddd",borderRadius:4,padding:"8px 12px",display:"flex",alignItems:"center",gap:8,marginBottom:16}}>
              <div style={{display:"flex",alignItems:"center",gap:4,fontSize:13,color:"#333",cursor:"pointer"}}>CNY <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
              <input value={cnyAmount} onChange={e=>setCnyAmount(e.target.value)} style={{flex:1,border:"none",outline:"none",fontSize:15,fontWeight:500,textAlign:"right"}}/>
            </div>
            <button style={{width:"100%",background:"#21c3bc",border:"none",borderRadius:4,padding:"10px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
              实时兑换 <svg width="10" height="10" viewBox="0 0 10 6" fill="#fff"><path d="M0 0l5 6 5-6z"/></svg>
            </button>
          </div>
          {/* 汇率图 */}
          <div>
            <div style={{fontSize:14,fontWeight:500,color:"#111",marginBottom:4}}>1 USD = 6.7546 CNY</div>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
              <span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>🔔 汇率提醒</span>
            </div>
            <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"10px",marginBottom:8}}>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#888",marginBottom:6}}>
                <span>■ 交易汇率</span>
                <div style={{display:"flex",alignItems:"center",gap:4}}>时间 7 天 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
              </div>
              <svg width="100%" height="120" viewBox="0 0 780 120">
                <line x1="60" y1="10" x2="60" y2="100" stroke="#f0f0f0" strokeWidth="1"/>
                <line x1="60" y1="100" x2="750" y2="100" stroke="#f0f0f0" strokeWidth="1"/>
                {[6.74,6.75,6.76,6.77,6.78,6.79].map((v,i)=>(
                  <text key={v} x="55" y={100-i*18} fontSize="9" fill="#bbb" textAnchor="end">{v}</text>
                ))}
                <polyline points={polyline} fill="none" stroke="#21c3bc" strokeWidth="2"/>
                {["06/08","06/09","06/10","06/11","06/12","06/13","06/14"].map((d,i)=>(
                  <text key={d} x={70+i*97} y="113" fontSize="9" fill="#bbb" textAnchor="middle">{d}</text>
                ))}
              </svg>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#888"}}>
              <div style={{width:24,height:24,borderRadius:"50%",border:"2px solid #21c3bc",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:"#21c3bc"}}>{timer}</div>
              <span>汇率每60秒刷新 最后更新时间：2026-06-14 03:31:04</span>
              <span style={{color:"#21c3bc",cursor:"pointer",marginLeft:"auto"}}>数据说明</span>
            </div>
          </div>
        </div>
      </div>

      {/* 交易记录 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
          <div style={{fontWeight:600,fontSize:15,color:"#111"}}>交易记录</div>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"5px 12px",fontSize:12,cursor:"pointer",color:"#555"}}>导出</button>
        </div>
        <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",marginBottom:14}}>
          {["全部","入账","出账"].map(t=>(
            <div key={t} onClick={()=>setActiveTab(t)} style={{padding:"8px 16px 8px 0",marginRight:16,fontSize:13,cursor:"pointer",color:activeTab===t?"#21c3bc":"#555",borderBottom:activeTab===t?"2px solid #21c3bc":"2px solid transparent",fontWeight:activeTab===t?500:400}}>{t}</div>
          ))}
        </div>
        {/* 筛选行 */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          <div style={{border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",fontSize:13,color:"#555",display:"flex",alignItems:"center",gap:4}}>
            2026-05-14 <span style={{color:"#bbb"}}>-</span> 2026-06-14
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          </div>
          <div style={{border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",fontSize:13,color:"#bbb",flex:1,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            交易类型 <svg width="8" height="5" viewBox="0 0 8 5" fill="#bbb"><path d="M0 0l4 5 4-5z"/></svg>
          </div>
          <input placeholder="输入业务订单号" style={{border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",fontSize:13,outline:"none",width:140}}/>
          <div style={{border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",fontSize:13,color:"#555",display:"flex",alignItems:"center",gap:4}}>币种 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
          <button style={{background:"none",border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",cursor:"pointer"}}>⟳</button>
          <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"6px 16px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500}}>搜索</button>
        </div>
        {/* 表头 */}
        <div style={{display:"grid",gridTemplateColumns:"1.5fr 1.5fr 1fr 1fr 0.8fr 0.6fr 0.6fr 1.5fr 1fr",padding:"10px 14px",background:"#fafafa",fontSize:12,color:"#888",fontWeight:500,borderBottom:"1px solid #f0f0f0",border:"1px solid #f0f0f0",borderRadius:"6px 6px 0 0"}}>
          <span>交易时间</span><span>交易流水号</span><span>交易类型</span><span>账号类型</span><span>交易状态</span><span>金额</span><span>币种</span><span>汇率</span><span style={{display:"flex",justifyContent:"space-between"}}>发起者 <span>业务订单号</span></span>
        </div>
        {/* 空状态 */}
        <div style={{border:"1px solid #f0f0f0",borderTop:"none",borderRadius:"0 0 6px 6px",padding:"40px",textAlign:"center"}}>
          <div style={{fontSize:48,marginBottom:12}}>🔍</div>
          <div style={{fontSize:13,color:"#888"}}>暂无记录</div>
        </div>
      </div>
    </div>
  );
}

// ── 财务页面 ──────────────────────────────────────────────────────────────────
function FinancePage() {
  const [subNav, setSubNav] = useState("财务概览");
  const subNavItems = ["财务概览","保证金","保险","收益数据分析","账单","钱包"];
  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>
      <div style={{width:178,background:"#fff",borderRight:"1px solid #ebebeb",flexShrink:0,paddingTop:4,overflowY:"auto"}}>
        {subNavItems.map(n=>(
          <div key={n} onClick={()=>setSubNav(n)} style={{padding:"9px 16px",fontSize:13,cursor:"pointer",color:subNav===n?"#21c3bc":"#333",background:subNav===n?"#f0fffe":"transparent",borderLeft:subNav===n?"3px solid #21c3bc":"3px solid transparent",fontWeight:subNav===n?500:400}}>{n}</div>
        ))}
      </div>
      <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
        {subNav==="财务概览"&&<FinanceOverview/>}
        {subNav==="保证金"&&<DepositPage/>}
        {subNav==="钱包"&&<WalletPage/>}
        {(subNav==="保险"||subNav==="收益数据分析"||subNav==="账单")&&<div style={{padding:24}}><div style={{background:"#fff",borderRadius:6,padding:"60px 40px",textAlign:"center",color:"#999",fontSize:13}}>页面建设中</div></div>}
      </div>
    </div>
  );
}

function FinanceOverview() {
  const [activeCard, setActiveCard] = useState("未结算");
  const [financeData, setFinanceData] = useState(()=>{
    const saved = loadFinance();
    return saved || {netIncome:"17.08", unsettled:"19.54", totalOrders:"6"};
  });
  const netIncome = financeData.netIncome;
  const unsettled = financeData.unsettled;
  const totalOrders = financeData.totalOrders || "6";
  const setNetIncome = (v) => { const next={...financeData,netIncome:v}; setFinanceData(next); saveFinance(next); };
  const setUnsettled = (v) => {
    const next={...financeData,unsettled:v};
    setFinanceData(next);
    saveFinance(next);
    // 同步到主页GMV
    try {
      const mainData = JSON.parse(localStorage.getItem('tts_data_v1')||'{}');
      mainData.gmv = Number(v) || 0;
      mainData.gmvDelta = "+0%";
      localStorage.setItem('tts_data_v1', JSON.stringify(mainData));
    } catch {}
  };
  const setTotalOrders = (v) => { const next={...financeData,totalOrders:v}; setFinanceData(next); saveFinance(next); };
  const [editNet, setEditNet] = useState(false);
  const [editUnsettled, setEditUnsettled] = useState(false);
  const [netVal, setNetVal] = useState("17.08");
  const [unsettledVal, setUnsettledVal] = useState("19.54");
  const [activeTab, setActiveTab] = useState("财务概览");
  const [editTotalOrders, setEditTotalOrders] = useState(false);
  const [totalOrdersVal, setTotalOrdersVal] = useState(financeData.totalOrders||"6");
  const tabs = ["财务概览","付款","结算单","未结算","发票","涉税信息报送数据"];

  const EF = ({value, editing, setEditing, val, setVal, onSave, prefix="$"}) => {
    if(editing) return (
      <span style={{display:"inline-flex",alignItems:"center",gap:2}}>
        <span>{prefix}</span>
        <input autoFocus value={val} onChange={e=>setVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){onSave(val);setEditing(false);}if(e.key==="Escape")setEditing(false);}} style={{border:"1px solid #21c3bc",borderRadius:2,padding:"0 4px",fontSize:"inherit",fontWeight:"inherit",width:80,outline:"none"}}/>
        <button onClick={()=>{onSave(val);setEditing(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 5px",fontSize:10,cursor:"pointer"}}>✓</button>
      </span>
    );
    return <span onDoubleClick={()=>{setVal(value);setEditing(true);}} style={{cursor:"default",borderBottom:"none"}} title="双击编辑">{prefix}{value}</span>;
  };

  return (
    <div style={{padding:"20px 24px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
        <div>
          <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:600,color:"#111"}}>概览</h2>
          <div style={{fontSize:12,color:"#888"}}>了解并管理店铺的付款和对账单。</div>
        </div>
        <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"7px 14px",fontSize:13,cursor:"pointer",color:"#333",display:"flex",alignItems:"center",gap:6}}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
          付款设置
        </button>
      </div>
      {/* Tab栏 */}
      <div style={{display:"flex",borderBottom:"1px solid #f0f0f0",marginBottom:16,background:"#fff",borderRadius:"6px 6px 0 0",padding:"0 16px"}}>
        {tabs.map((t,i)=>(
          <div key={t} onClick={()=>setActiveTab(t)} style={{padding:"12px 14px",fontSize:13,cursor:"pointer",color:activeTab===t?"#21c3bc":"#555",borderBottom:activeTab===t?"2px solid #21c3bc":"2px solid transparent",fontWeight:activeTab===t?500:400,whiteSpace:"nowrap"}}>{t}</div>
        ))}
      </div>

      {/* 四个数据卡片 */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:16}}>
        {[
          {label:"净收益",hint:true,arrow:true,value:<EF value={netIncome} editing={editNet} setEditing={setEditNet} val={netVal} setVal={setNetVal} onSave={setNetIncome}/>,sub:<span style={{color:"#21c3bc",cursor:"pointer",fontSize:12}}>付款频次：每周一</span>,border:false,active:activeCard==="净收益"},
          {label:"已到账",hint:true,value:"--",sub:"本周",border:true,active:activeCard==="已到账"},
          {label:"正在处理",hint:true,value:"--",sub:"预计 1-3 个工作日",border:false,active:activeCard==="正在处理",borderLeft:activeCard==="正在处理"},
          {label:"未结算",hint:true,value:<span style={{fontSize:22,fontWeight:700,color:"#111"}}>${(()=>{try{const d=JSON.parse(localStorage.getItem('tts_data_v1')||'{}');return Number(d.gmv||0).toFixed(2);}catch{return unsettled;}})()}</span>,sub:"迄今",border:false,active:activeCard==="未结算"},
        ].map((card,i)=>(
          <div key={i} onClick={()=>setActiveCard(card.label)} style={{background:card.active?"#f0fffe":"#fff",border:card.active?"2px solid #21c3bc":"1px solid #f0f0f0",borderRadius:6,padding:"16px",cursor:"pointer"}}>
            <div style={{display:"flex",alignItems:"center",gap:4,fontSize:12,color:"#888",marginBottom:8}}>
              {card.label}
              {card.hint&&<span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span>}
              {card.arrow&&<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>}
            </div>
            <div style={{fontSize:22,fontWeight:700,color:"#111",marginBottom:6}}>{card.value}</div>
            <div style={{fontSize:12,color:"#888"}}>{card.sub}</div>
          </div>
        ))}
      </div>

      {/* 条件区域 - 根据点击卡片显示不同内容 */}
      {activeCard==="未结算" && (
        <div style={{background:"#fff",borderRadius:6,padding:"20px",marginBottom:16}}>
          <div style={{fontSize:13,color:"#555",marginBottom:4}}>当前结算周期 <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999",marginLeft:4}}>?</span></div>
          <div style={{fontWeight:600,fontSize:16,color:"#111",marginBottom:4}}>送达后 31 天 / 延期结算周期</div>
          <div style={{color:"#21c3bc",fontSize:12,cursor:"pointer",marginBottom:24}}>如何解锁更快付款</div>
          {/* 圆环图 */}
          <div style={{display:"flex",justifyContent:"center",marginBottom:16}}>
            <div style={{position:"relative",width:200,height:200}}>
              <svg width="200" height="200" viewBox="0 0 200 200">
                <circle cx="100" cy="100" r="75" fill="none" stroke="#f0f0f0" strokeWidth="28"/>
                <circle cx="100" cy="100" r="75" fill="none" stroke="#fa8c16" strokeWidth="28" strokeDasharray="460 12" strokeDashoffset="115" strokeLinecap="round"/>
              </svg>
            </div>
          </div>
          <div style={{textAlign:"center",fontSize:12,color:"#888",marginBottom:16}}>
            订单已送达，等待结算 <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span> ${(()=>{try{const d=JSON.parse(localStorage.getItem('tts_data_v1')||'{}');return Number(d.gmv||0).toFixed(2);}catch{return unsettled;}})()} 
          </div>
          <div style={{fontSize:13,color:"#555",display:"flex",alignItems:"center",gap:4}}>
            未结算订单的详细信息
            <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span>
            <span style={{color:"#21c3bc",cursor:"pointer"}}>
              查看全部 <span style={{marginLeft:2}}>{(()=>{try{const d=JSON.parse(localStorage.getItem('tts_data_v1')||'{}');return Math.round(d.orders)||totalOrders;}catch{return totalOrders;}})()}</span> &gt;
            </span>
          </div>
        </div>
      )}

      {activeCard==="正在处理" && (
        <div style={{background:"#fff",borderRadius:6,padding:"20px",marginBottom:16}}>
          <div style={{textAlign:"center",padding:"30px 0",borderBottom:"1px solid #f0f0f0",marginBottom:20}}>
            <div style={{fontSize:13,color:"#888"}}>此处显示正在处理的信息。</div>
          </div>
          <div style={{marginBottom:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <div style={{fontWeight:600,fontSize:14,color:"#111"}}>付款设置</div>
              <div style={{display:"flex",alignItems:"center",gap:4,color:"#21c3bc",fontSize:13,cursor:"pointer"}}>设置 <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg></div>
            </div>
            <div style={{fontSize:12,color:"#888",marginBottom:4}}>钱包 ID</div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <span style={{fontSize:13,color:"#111"}}>48*****85</span>
              <span style={{background:"#f6ffed",color:"#52c41a",border:"1px solid #b7eb8f",borderRadius:3,padding:"1px 8px",fontSize:11}}>有效</span>
            </div>
            <div style={{fontSize:12,color:"#555",lineHeight:1.7}}>提醒：切换到新的银行账号后，应将其设置为你的主账号，以便将资金转入该账号。</div>
          </div>
          <div>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:12}}>了解财务信息</div>
            <div style={{border:"1px solid #f0f0f0",borderRadius:4,padding:"14px 16px",cursor:"pointer"}}>
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:20}}>📊</span>
                  <div>
                    <div style={{fontSize:13,color:"#333",fontWeight:500}}>我什么时候能收到付款？</div>
                    <div style={{color:"#21c3bc",fontSize:12,marginTop:2,cursor:"pointer"}}>查看详情</div>
                  </div>
                </div>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeCard==="净收益" && (
        <div style={{background:"#fff",borderRadius:6,padding:"20px",marginBottom:16}}>
          {/* 最近的账单 */}
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <div style={{fontWeight:600,fontSize:14,color:"#111"}}>最近的账单</div>
            <div style={{display:"flex",alignItems:"center",gap:4,fontSize:12,color:"#21c3bc",cursor:"pointer"}}>
              查看全部 0 <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div>
          <div style={{textAlign:"center",padding:"40px 0",borderBottom:"1px solid #f0f0f0",marginBottom:20}}>
            <div style={{fontSize:40,marginBottom:8,opacity:0.3}}>📄</div>
            <div style={{fontSize:13,color:"#bbb"}}>暂无内容</div>
          </div>
          {/* 付款设置 */}
          <div style={{marginBottom:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
              <div style={{fontWeight:600,fontSize:14,color:"#111"}}>付款设置</div>
              <div style={{display:"flex",alignItems:"center",gap:4,color:"#21c3bc",fontSize:13,cursor:"pointer"}}>
                设置 <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            </div>
            <div style={{fontSize:12,color:"#888",marginBottom:4}}>钱包 ID</div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <span style={{fontSize:13,color:"#111"}}>48*****85</span>
              <span style={{background:"#f6ffed",color:"#52c41a",border:"1px solid #b7eb8f",borderRadius:3,padding:"1px 8px",fontSize:11}}>有效</span>
            </div>
            <div style={{fontSize:12,color:"#555",lineHeight:1.7}}>提醒：切换到新的银行账号后，应将其设置为你的主账号，以便将资金转入该账号。</div>
          </div>
          {/* 了解财务信息 */}
          <div>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:12}}>了解财务信息</div>
            {[
              "我什么时候能收到付款？",
              "付款到账后我在哪里查看？",
              "为什么我的付款金额与预期不符？",
            ].map((q,i)=>(
              <div key={i} style={{border:"1px solid #f0f0f0",borderRadius:4,padding:"12px 16px",marginBottom:8,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{color:"#fa8c16",fontSize:16}}>→</span>
                  <span style={{fontSize:13,color:"#333"}}>{q}</span>
                </div>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeCard==="已到账" && (
        <div style={{background:"#fff",borderRadius:6,padding:"20px",marginBottom:16}}>
          <div style={{display:"flex",gap:8,marginBottom:16}}>
            {["本周","上周","上个月"].map(t=>(
              <button key={t} style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#555"}}>{t}</button>
            ))}
            <div style={{border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,color:"#555",display:"flex",alignItems:"center",gap:6}}>
              2026/06/08 - 2026/06/14
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </div>
          </div>
          <div style={{textAlign:"center",padding:"20px",color:"#999",fontSize:13}}>此处显示近期付款信息。</div>
          <div style={{marginTop:20,padding:"16px",border:"1px solid #f0f0f0",borderRadius:6}}>
            <div style={{fontWeight:500,fontSize:14,color:"#111",marginBottom:10}}>付款设置</div>
            <div style={{fontSize:12,color:"#888",marginBottom:4}}>钱包 ID</div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <span style={{fontSize:13,color:"#111"}}>48*****85</span>
              <span style={{background:"#f6ffed",color:"#52c41a",border:"1px solid #b7eb8f",borderRadius:3,padding:"1px 8px",fontSize:11}}>有效</span>
            </div>
            <div style={{fontSize:12,color:"#888"}}>提醒：切换到新的银行账号后，应将其设置为你的主账号，以便将资金转入该账号。</div>
          </div>
          <div style={{marginTop:16,border:"1px solid #f0f0f0",borderRadius:6,padding:"16px"}}>
            <div style={{fontWeight:500,fontSize:14,color:"#111",marginBottom:14}}>了解财务信息</div>
            <div style={{border:"1px solid #f0f0f0",borderRadius:4,padding:"12px 16px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}><span style={{color:"#fa8c16"}}>→</span><span style={{fontSize:13,color:"#333"}}>我什么时候能收到付款？</span></div>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── 明星商家认证计划 ──────────────────────────────────────────────────────────
function StarMerchantPage() {
  const [reputation, setReputation] = useState("4.2");
  const [editRep, setEditRep] = useState(false);
  const [repVal, setRepVal] = useState("4.2");
  const [orderCounts, setOrderCounts] = useState({5:1,4:0,3:0,2:0,1:0,0:4});
  const [scores, setScores] = useState({5:"1.0",4:"0.0",3:"0.0",2:"0.0",1:"0.0",0:"+3.2"});

  const criteria = {
    普通商家: [{icon:"🏪",label:"店铺状态：正常",pass:true}],
    银星级商家: [
      {icon:"✦",label:"商家信誉分 > 2000.0",pass:false},
      {icon:"📊",label:"好评率 ≥ 80.0%",pass:true},
      {icon:"🛡",label:"店铺体验分 ≥ 4.0",pass:false},
      {icon:"📦",label:"商品数 ≥ 1",pass:true},
      {icon:"📖",label:"店铺有徽标",pass:true},
    ],
    金星级商家: [
      {icon:"✦",label:"商家信誉分 > 10000.0",pass:false},
      {icon:"📊",label:"好评率 ≥ 80.0%",pass:true},
      {icon:"🛡",label:"店铺体验分 ≥ 4.0",pass:false},
      {icon:"📦",label:"商品数 ≥ 1",pass:true},
      {icon:"📖",label:"店铺有徽标",pass:true},
    ],
  };

  const starRatings = [
    {stars:5,color:"#faad14",label:"5 星评分",delta:"+1 分"},
    {stars:4,color:"#faad14",label:"4 星评分",delta:"+1 分"},
    {stars:3,color:"#faad14",label:"3 星评分",delta:"-0.4 分"},
    {stars:2,color:"#faad14",label:"2 星评分",delta:"-1 分"},
    {stars:1,color:"#faad14",label:"1 星评分",delta:"-1 分"},
    {stars:0,color:"#888",label:"无评分",delta:"+0.8 分"},
  ];

  return (
    <div style={{padding:"20px 24px"}}>
      <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:600,color:"#111"}}>明星商家认证计划</h2>
      <div style={{fontSize:12,color:"#888",marginBottom:20}}>
        平台会对在选品、商品质量等关键指标上持续打造优秀客户体验的店铺授予"明星商家"徽章。<span style={{color:"#21c3bc",cursor:"pointer"}}>更多详情</span>
      </div>
      {/* 当前等级 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontWeight:600,fontSize:15,color:"#111",marginBottom:16}}>你尚未获得明星商家徽章</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
          {[
            {label:"普通商家",active:true,icon:null,color:"#111"},
            {label:"银星级商家",active:false,icon:"🔵",color:"#888",sub:"解锁银星级商家徽章领取权益"},
            {label:"金星级商家",active:false,icon:"🟡",color:"#888"},
          ].map(tier=>(
            <div key={tier.label} style={{border:`2px solid ${tier.active?"#333":"#f0f0f0"}`,borderRadius:8,padding:"20px",textAlign:"center",background:tier.active?"#fff":"#fafafa"}}>
              {tier.icon&&<div style={{fontSize:24,marginBottom:8}}>{tier.icon}</div>}
              <div style={{fontWeight:tier.active?700:500,fontSize:15,color:tier.color}}>{tier.label}</div>
              {tier.sub&&<div style={{fontSize:11,color:"#21c3bc",marginTop:8,cursor:"pointer"}}>{tier.sub}</div>}
            </div>
          ))}
        </div>
      </div>
      {/* 明星商家标准 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px",marginBottom:16}}>
        <div style={{fontWeight:600,fontSize:15,color:"#111",marginBottom:16}}>明星商家标准</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
          {Object.entries(criteria).map(([name,items])=>(
            <div key={name} style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px"}}>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}>
                {name!=="普通商家"&&<span style={{fontSize:16}}>{name==="银星级商家"?"🔵":"🟡"}</span>}
                <span style={{fontWeight:600,fontSize:14,color:name==="普通商家"?"#111":name==="银星级商家"?"#4096ff":"#faad14"}}>{name}</span>
              </div>
              <div style={{fontSize:12,color:"#888",marginBottom:8}}>标准</div>
              {items.map((item,i)=>(
                <div key={i} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"6px 0",borderBottom:"1px solid #f5f5f5"}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"#333"}}>
                    <span style={{fontSize:14}}>{item.icon}</span>
                    <span>{item.label}</span>
                  </div>
                  <span style={{color:item.pass?"#52c41a":"#ff4d4f",fontSize:14}}>{item.pass?"✓":"✗"}</span>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
      {/* 商家信誉分 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px 24px"}}>
        <div style={{fontWeight:600,fontSize:15,color:"#111",marginBottom:4}}>商家信誉分</div>
        <div style={{fontSize:12,color:"#888",marginBottom:16}}>我们使用商品评分记录和订单量来计算商家信誉分，以衡量商家在平台上的长期表现。</div>
        <div style={{fontSize:32,fontWeight:700,color:"#111",marginBottom:8}}>
          {editRep
            ? <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                <input autoFocus value={repVal} onChange={e=>setRepVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setReputation(repVal);setEditRep(false);}}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"0 6px",fontSize:28,fontWeight:700,width:80,outline:"none"}}/>
                <button onClick={()=>{setReputation(repVal);setEditRep(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"3px 8px",fontSize:12,cursor:"pointer"}}>✓</button>
              </span>
            : <span onDoubleClick={()=>{setRepVal(reputation);setEditRep(true);}} style={{cursor:"default",borderBottom:"none"}}>{reputation}</span>
          }
        </div>
        <div style={{display:"flex",gap:24,fontSize:12,color:"#888",marginBottom:20,paddingBottom:12,borderBottom:"1px solid #f0f0f0"}}>
          <span>上次更新时间: 10/06/2026</span>
          <span style={{borderLeft:"1px solid #ddd",paddingLeft:24}}>较上周 ▲ 0.0</span>
          <span style={{borderLeft:"1px solid #ddd",paddingLeft:24}}>已运营 54 天</span>
          <span style={{borderLeft:"1px solid #ddd",paddingLeft:24,color:"#21c3bc",cursor:"pointer"}}>更多详情</span>
        </div>
        {/* 评分表格 */}
        <div style={{border:"1px solid #f0f0f0",borderRadius:6,overflow:"hidden"}}>
          <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",padding:"10px 16px",background:"#fafafa",fontSize:12,color:"#888",fontWeight:500,borderBottom:"1px solid #f0f0f0"}}>
            <span>商品评分</span><span>订单数量</span><span>积分</span><span>操作</span>
          </div>
          {starRatings.map(r=>{
            const starCount = r.stars;
            return (
              <div key={r.label} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",padding:"12px 16px",borderBottom:"1px solid #f5f5f5",alignItems:"center"}}>
                <div>
                  <div style={{display:"flex",alignItems:"center",gap:2,marginBottom:2}}>
                    {starCount>0?Array(starCount).fill(0).map((_,i)=><span key={i} style={{color:"#faad14",fontSize:14}}>★</span>):<span style={{fontSize:13,color:"#555"}}>无</span>}
                    {starCount>0&&<span style={{fontSize:13,color:"#333",marginLeft:4}}>{r.label.replace(/[★]/g,"")}</span>}
                    {starCount===0&&<span style={{fontSize:13,color:"#333",marginLeft:4}}>评分</span>}
                  </div>
                  <div style={{fontSize:11,color:"#888"}}>{r.delta}</div>
                </div>
                <div style={{fontSize:13,color:"#333"}}>{orderCounts[starCount]}</div>
                <div style={{fontSize:13,color:"#333"}}>{scores[starCount]}</div>
                <button style={{background:"#f5f5f5",border:"1px solid #ddd",borderRadius:4,padding:"4px 10px",fontSize:12,cursor:"pointer",color:"#555",width:"fit-content"}}>查看详情</button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// 更新SPS页面添加仪表盘图
function SPSDashboardSection() {
  return (
    <div style={{background:"#fff",borderRadius:6,padding:"32px 24px",textAlign:"center",marginBottom:16}}>
      <div style={{fontWeight:700,fontSize:18,color:"#111",marginBottom:12}}>什么是 SPS?</div>
      <div style={{fontSize:13,color:"#555",lineHeight:1.8,maxWidth:600,margin:"0 auto 24px"}}>
        店铺体验分（SPS）是一个动态评分系统（0-5 分），旨在帮助你拓展业务。SPS 由商品满意度、履约与物流以及客户服务三大表现指标决定。
      </div>
      {/* SVG半圆仪表盘 */}
      <div style={{display:"flex",justifyContent:"center",marginBottom:16}}>
        <svg width="320" height="180" viewBox="0 0 320 180">
          {/* 背景圆弧 */}
          <path d="M 30 160 A 130 130 0 0 1 290 160" fill="none" stroke="#e8e8e8" strokeWidth="20" strokeLinecap="round"/>
          {/* 蓝色段 */}
          <path d="M 30 160 A 130 130 0 0 1 100 50" fill="none" stroke="#4096ff" strokeWidth="20" strokeLinecap="round"/>
          {/* 青色段 */}
          <path d="M 100 50 A 130 130 0 0 1 190 36" fill="none" stroke="#21c3bc" strokeWidth="20" strokeLinecap="round"/>
          {/* 黄色段 */}
          <path d="M 190 36 A 130 130 0 0 1 260 85" fill="none" stroke="#faad14" strokeWidth="20" strokeLinecap="round"/>
          {/* 中心文字 */}
          <text x="160" y="135" textAnchor="middle" fontSize="24" fontWeight="700" fill="#111">SPS</text>
          <text x="160" y="155" textAnchor="middle" fontSize="12" fill="#888">店铺体验分</text>
          {/* 刻度标签 */}
          <text x="18" y="168" fontSize="11" fill="#888">0</text>
          <text x="72" y="52" fontSize="11" fill="#888">1</text>
          <text x="148" y="28" fontSize="11" fill="#888">2</text>
          <text x="215" y="28" fontSize="11" fill="#888">3</text>
          <text x="278" y="52" fontSize="11" fill="#888">4</text>
          <text x="296" y="168" fontSize="11" fill="#888">5</text>
        </svg>
      </div>
      {/* 三大指标 */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:12,marginBottom:12}}>
        {[
          {pct:"40%",color:"#4096ff",label:"商品满意度",metrics:["60 天差评率","60 天非买家责任退货退数率"]},
          {pct:"40%",color:"#21c3bc",label:"履约与物流",metrics:["30 天商费取消率","30 天按时送达率"]},
          {pct:"30%",color:"#faad14",label:"客户服务",metrics:["60 天售后响应时长","60 天咨询不满意度"]},
        ].map(c=>(
          <div key={c.label} style={{border:"1px solid #f0f0f0",borderRadius:8,padding:"14px",textAlign:"left"}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
              <span style={{width:28,height:28,borderRadius:"50%",background:"#f0f0f0",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#666",fontWeight:600}}>×</span>
              <span style={{fontWeight:600,fontSize:14,color:"#111"}}>{c.pct}</span>
              <span style={{width:28,height:28,borderRadius:"50%",background:"#f0f0f0",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"#666",fontWeight:600}}>*</span>
            </div>
            <div style={{fontSize:12,color:"#555",marginBottom:8,fontWeight:500}}>{c.label}</div>
            <div style={{height:4,background:"#f0f0f0",borderRadius:2,overflow:"hidden",marginBottom:8}}>
              <div style={{height:"100%",width:"60%",background:c.color,borderRadius:2}}/>
            </div>
            <div style={{fontSize:11,color:"#888",marginBottom:4}}>0 ~ 5.0</div>
            <div style={{fontSize:11,color:"#888",marginTop:8}}>评估依据</div>
            {c.metrics.map(m=><div key={m} style={{fontSize:11,color:"#555",marginTop:4,display:"flex",alignItems:"center",gap:4}}>{m} <span style={{width:12,height:12,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:8,color:"#999"}}>?</span></div>)}
          </div>
        ))}
      </div>
      <div style={{fontSize:11,color:"#888"}}>*这是一个示例。各个表现指标的影响因类目而异。</div>
    </div>
  );
}

// ── 联盟页面 ──────────────────────────────────────────────────────────────────
function AffiliatePage() {
  const shopName = "Neighbor Gems";
  const cards = [
    {icon:"📢",color:"#4096ff",bg:"#e6f4ff",title:"公开合作设置",sub:"添加商品，让 8000 万名达人与他们的粉丝分享。"},
    {icon:"📋",color:"#52c41a",bg:"#f6ffed",title:"定向合作设置",sub:"邀请你喜欢的达人试用并推广你的商品。"},
    {icon:"🔍",color:"#fa8c16",bg:"#fff7e6",title:"寻找达人",sub:"发现与你的品牌和商品匹配的达人。"},
    {icon:"🎁",color:"#21c3bc",bg:"#e6fff9",title:"样品申请管理",sub:"管理你的样品，查看领取样品的达人和带货情况。"},
    {icon:"📊",color:"#faad14",bg:"#fffbe6",title:"数据洞察",sub:"查看商品和合作计划的表现，获取可用的数据分析信息。"},
    {icon:"🎓",color:"#1677ff",bg:"#e6f4ff",title:"商家学习中心",sub:"学习成功的技巧和窍门，获取帮助以及更多。"},
  ];
  return (
    <div style={{flex:1,background:"#f5f5f5",overflowY:"auto",padding:"32px 40px"}}>
      <div style={{marginBottom:8}}>
        <h2 style={{margin:"0 0 6px",fontSize:20,fontWeight:600,color:"#111"}}>{shopName} 你好！欢迎来到 TikTok Shop 联盟</h2>
        <div style={{fontSize:13,color:"#888"}}>选择你要做什么，或直接进入联盟首页。</div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16,margin:"24px 0 32px"}}>
        {cards.map(c=>(
          <div key={c.title} style={{background:"#fff",borderRadius:8,padding:"28px 24px",cursor:"pointer",transition:"box-shadow 0.2s",border:"1px solid #f0f0f0"}}>
            <div style={{width:48,height:48,borderRadius:"50%",background:c.bg,display:"flex",alignItems:"center",justifyContent:"center",fontSize:24,marginBottom:16}}>{c.icon}</div>
            <div style={{fontWeight:600,fontSize:15,color:"#111",marginBottom:8}}>{c.title}</div>
            <div style={{fontSize:12,color:"#888",lineHeight:1.7}}>{c.sub}</div>
          </div>
        ))}
      </div>
      <div style={{textAlign:"center"}}>
        <span style={{color:"#21c3bc",fontSize:14,cursor:"pointer",fontWeight:500}}>前往 TikTok Shop 联盟首页 →</span>
      </div>
    </div>
  );
}

// ── 账号健康页面 ──────────────────────────────────────────────────────────────
function HealthPage() {
  const [subNav, setSubNav] = useState("店铺健康");
  const subNavItems = ["店铺健康","店铺体验分","达人健康评分","明星商家认证计划","用户之声"];
  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>
      <div style={{width:178,background:"#fff",borderRight:"1px solid #ebebeb",flexShrink:0,paddingTop:4,overflowY:"auto"}}>
        {subNavItems.map(n=>(
          <div key={n} onClick={()=>setSubNav(n)} style={{padding:"9px 16px",fontSize:13,cursor:"pointer",color:subNav===n?"#21c3bc":"#333",background:subNav===n?"#f0fffe":"transparent",borderLeft:subNav===n?"3px solid #21c3bc":"3px solid transparent",fontWeight:subNav===n?500:400}}>{n}</div>
        ))}
      </div>
      <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
        {subNav==="店铺健康"&&<ShopHealthPage/>}
        {subNav==="店铺体验分"&&<SPSPage/>}
        {subNav==="明星商家认证计划"&&<StarMerchantPage/>}
        {(subNav==="达人健康评分"||subNav==="用户之声")&&(
          <div style={{padding:24}}><div style={{background:"#fff",borderRadius:6,padding:"60px 40px",textAlign:"center",color:"#999",fontSize:13}}>页面建设中</div></div>
        )}
      </div>
    </div>
  );
}

function ShopHealthPage() {
  const [score, setScore] = useState("200");
  const [editScore, setEditScore] = useState(false);
  const [scoreVal, setScoreVal] = useState("200");
  const [metrics, setMetrics] = useState({
    delay:"--", cancelRate:"0%", returnRate:"--", onTime:"--",
    fair:"1", account:"0", review:"0", fulfill:"0", ip:"0", quality:"0", other:"0", product:"0", safety:"0"
  });
  const setMetric = (k,v) => setMetrics(m=>({...m,[k]:v}));
  const EF = ({k,style={}}) => {
    const [ed,setEd] = useState(false);
    const [v,setV] = useState(metrics[k]);
    if(ed) return <span style={{display:"inline-flex",alignItems:"center",gap:2}}><input autoFocus value={v} onChange={e=>setV(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setMetric(k,v);setEd(false);}if(e.key==="Escape")setEd(false);}} style={{border:"1px solid #21c3bc",borderRadius:2,padding:"0 4px",fontSize:"inherit",fontWeight:"inherit",width:60,outline:"none",...style}}/><button onClick={()=>{setMetric(k,v);setEd(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 5px",fontSize:10,cursor:"pointer"}}>✓</button></span>;
    return <span onDoubleClick={()=>{setV(metrics[k]);setEd(true);}} style={{cursor:"default",borderBottom:"none",...style}} title="双击编辑">{metrics[k]}</span>;
  };
  const scoreNum = parseInt(score)||0;
  const pct = Math.min((scoreNum/200)*100,100);

  return (
    <div style={{padding:"20px 24px"}}>
      <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:600,color:"#111"}}>账号健康分</h2>
      {/* Tab */}
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",marginBottom:16,background:"#fff",borderRadius:"6px 6px 0 0",padding:"0 16px"}}>
        {["概览","违规记录","警告记录","学习中心"].map((t,i)=>(
          <div key={t} style={{padding:"12px 16px",fontSize:13,cursor:"pointer",color:i===0?"#21c3bc":"#555",borderBottom:i===0?"2px solid #21c3bc":"2px solid transparent",fontWeight:i===0?500:400}}>{t}</div>
        ))}
      </div>
      {/* 健康分卡片 */}
      <div style={{background:"#f6ffed",borderRadius:6,padding:"20px 24px",marginBottom:12,border:"1px solid #d9f7be"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
              <span style={{fontWeight:700,fontSize:16,color:"#111"}}>健康</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#666" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
            </div>
            <div style={{fontSize:13,color:"#555",marginBottom:16}}>你的账号很健康。请再接再厉！</div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:6,fontSize:12,color:"#21c3bc",cursor:"pointer"}}>节点记录 <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg></div>
        </div>
        {/* 分数条 */}
        <div style={{marginBottom:8,textAlign:"center",position:"relative"}}>
          <div style={{position:"absolute",left:`${pct}%`,top:-20,transform:"translateX(-50%)",textAlign:"center"}}>
            <div style={{fontWeight:700,fontSize:14,color:"#111"}}>
              {editScore
                ? <span style={{display:"inline-flex",alignItems:"center",gap:2}}>
                    <input autoFocus value={scoreVal} onChange={e=>setScoreVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setScore(scoreVal);setEditScore(false);}}} style={{border:"1px solid #21c3bc",borderRadius:2,padding:"0 4px",fontSize:14,fontWeight:700,width:55,outline:"none"}}/>
                    <button onClick={()=>{setScore(scoreVal);setEditScore(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 4px",fontSize:10,cursor:"pointer"}}>✓</button>
                  </span>
                : <span onDoubleClick={()=>{setScoreVal(score);setEditScore(true);}} style={{cursor:"default",borderBottom:"none"}}>{score}</span>
              }
            </div>
            <div style={{color:"#52c41a",fontSize:14}}>▼</div>
          </div>
        </div>
        <div style={{height:20,background:"#e8e8e8",borderRadius:4,overflow:"hidden",marginTop:28,marginBottom:6}}>
          <div style={{height:"100%",width:`${pct}%`,background:"#52c41a",borderRadius:4,transition:"width 0.3s"}}/>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#888"}}>
          <span>0</span><span>50</span><span>100</span><span>150</span><span>200（默认）</span><span style={{marginLeft:"auto"}}>1000</span>
        </div>
      </div>
      {/* 需要处理 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:12}}>
        <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:14}}>需要处理</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:"#555",marginBottom:6}}>
              可参加考试
              <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span>
            </div>
            <div style={{fontSize:22,fontWeight:700,color:"#111",marginBottom:4}}>0</div>
            <div style={{fontSize:12,color:"#888"}}>通过考试即可提高你的账号健康评分</div>
          </div>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"6px 18px",fontSize:13,cursor:"pointer",color:"#333"}}>查看</button>
        </div>
      </div>
      {/* 指标表现 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:12}}>
        <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:14}}>指标表现</div>
        <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px 20px",marginBottom:12}}>
          <div style={{fontWeight:500,fontSize:14,color:"#111",marginBottom:14}}>订单履约违规</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:0}}>
            {[
              {label:"延迟发货率",k:"delay",target:"目标值 < 4%",border:true},
              {label:"商费取消率",k:"cancelRate",target:"目标值 < 2.5%",border:false},
              {label:"有效追踪率",k:"returnRate",target:"目标值 > 95%",border:true},
              {label:"按时送达率",k:"onTime",target:"目标值 >= 90%",border:false},
            ].map((m,i)=>(
              <div key={m.label} style={{padding:"12px 16px",borderBottom:i<2?"1px solid #f5f5f5":"none",borderRight:i%2===0?"1px solid #f5f5f5":"none"}}>
                <div style={{display:"flex",alignItems:"center",gap:4,fontSize:13,color:"#555",marginBottom:6}}>
                  {m.label}
                  <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
                </div>
                <div style={{fontSize:16,fontWeight:600,color:"#111",marginBottom:4}}><EF k={m.k}/></div>
                <div style={{fontSize:11,color:"#888"}}>{m.target}</div>
              </div>
            ))}
          </div>
        </div>
        {/* 政策违规 */}
        <div>
          <div style={{fontWeight:500,fontSize:14,color:"#111",marginBottom:14}}>政策违规</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10}}>
            {[
              {label:"公平交易",k:"fair"},{label:"账号管理",k:"account"},{label:"客户评价",k:"review"},
              {label:"履约和售后",k:"fulfill"},{label:"知识产权",k:"ip"},{label:"发品质量",k:"quality"},
              {label:"其他",k:"other"},{label:"商品合规",k:"product"},{label:"商品安全",k:"safety"},
            ].map(m=>(
              <div key={m.label} style={{border:"1px solid #f0f0f0",borderRadius:4,padding:"10px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
                <div>
                  <div style={{fontSize:13,color:"#333",marginBottom:3}}>{m.label}</div>
                  <div style={{fontSize:12,color:"#888"}}><EF k={m.k}/> 个相关</div>
                </div>
                <svg width="10" height="14" viewBox="0 0 10 14" fill="none" stroke="#bbb" strokeWidth="1.5"><path d="M3 3l4 4-4 4"/></svg>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function SPSPage() {
  const [orderCount, setOrderCount] = useState("10");
  const [editOrder, setEditOrder] = useState(false);
  const [orderVal, setOrderVal] = useState("10");
  const pct = Math.min((parseInt(orderCount)||0)/30*100,100);
  return (
    <div style={{padding:"20px 24px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:4}}>
        <div>
          <h2 style={{margin:"0 0 4px",fontSize:20,fontWeight:600,color:"#111"}}>店铺体验分</h2>
          <div style={{fontSize:12,color:"#888",marginBottom:0}}>
            请时刻关注你的店铺表现，采取行动改善指标并解锁更多权益。
            <span style={{color:"#21c3bc",cursor:"pointer",marginLeft:6}}>查看商家体验分规范</span>
          </div>
        </div>
      </div>
      {/* 主卡片 */}
      <div style={{background:"#fff",borderRadius:6,padding:"24px",marginBottom:12,marginTop:16}}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <div style={{width:8,height:8,borderRadius:"50%",background:"#888"}}/>
          <span style={{fontSize:12,color:"#888"}}>暂无评分</span>
        </div>
        <div style={{fontSize:22,fontWeight:700,color:"#111",marginBottom:12,lineHeight:1.4}}>
          90 天内完成 30 个订单即可解锁<span style={{color:"#21c3bc"}}>分数</span>和<span style={{color:"#21c3bc"}}>权益</span>
        </div>
        {/* 进度 */}
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <div style={{fontSize:14,color:"#555",display:"flex",alignItems:"center",gap:6}}>
            {editOrder
              ? <span style={{display:"inline-flex",alignItems:"center",gap:2}}>
                  <input autoFocus value={orderVal} onChange={e=>setOrderVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setOrderCount(orderVal);setEditOrder(false);}}} style={{border:"1px solid #21c3bc",borderRadius:2,padding:"0 4px",fontSize:14,fontWeight:700,width:50,outline:"none"}}/>
                  <button onClick={()=>{setOrderCount(orderVal);setEditOrder(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 4px",fontSize:10,cursor:"pointer"}}>✓</button>
                </span>
              : <span onDoubleClick={()=>{setOrderVal(orderCount);setEditOrder(true);}} style={{fontWeight:700,fontSize:18,color:"#21c3bc",cursor:"pointer",borderBottom:"none"}}>{orderCount}</span>
            }
            <span style={{color:"#888"}}>/30 有效送达订单数 不包括 0 个例外订单</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>
          </div>
          <div style={{fontSize:12,color:"#888"}}>数据更新于 2026/06/13 <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999"}}>?</span></div>
        </div>
        <div style={{height:8,background:"#e8e8e8",borderRadius:4,overflow:"hidden",marginBottom:20}}>
          <div style={{height:"100%",width:`${pct}%`,background:"#21c3bc",borderRadius:4,transition:"width 0.3s"}}/>
        </div>
        {/* 权益卡片 */}
        <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
            <span style={{fontWeight:500,fontSize:13,color:"#111"}}>最多可获得 11 项权益</span>
            <span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>查看所有权益</span>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12}}>
            {[
              {icon:"📈",label:"广告投放",score:"解锁分数 = 2.5"},
              {icon:"⚡",label:"秒杀工具",score:"解锁分数 = 2.5"},
              {icon:"🚀",label:"提升流量 +10%",score:"解锁分数 = 2.5"},
              {icon:"🚀",label:"提升流量 +20%",score:"解锁分数 = 3.5"},
            ].map(b=>(
              <div key={b.label} style={{textAlign:"center",padding:"12px 8px",border:"1px solid #f0f0f0",borderRadius:6}}>
                <div style={{fontSize:28,marginBottom:6,opacity:0.4}}>{b.icon}</div>
                <div style={{fontSize:12,color:"#333",marginBottom:4,fontWeight:500}}>{b.label}</div>
                <div style={{fontSize:11,color:"#888"}}>{b.score}</div>
              </div>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"center",gap:6,marginTop:12}}>
            {[0,1,2].map(i=><div key={i} style={{width:8,height:8,borderRadius:"50%",background:i===0?"#333":"#ddd"}}/>)}
          </div>
        </div>
        <div style={{marginTop:14,fontSize:12,color:"#888"}}>
          订单尚未发货？<span style={{color:"#21c3bc",cursor:"pointer",fontWeight:500}}>去发货 &gt;</span>
        </div>
      </div>
      <SPSDashboardSection/>
    </div>
  );
}

// ── 广告营销页面 ──────────────────────────────────────────────────────────────
function AdsPage() {
  const [subNav, setSubNav] = useState("店铺广告");
  const subNavItems = [
    {id:"促销活动", label:"促销活动"},
    {id:"搜索数据分析", label:"搜索数据分析", badge:"NEW"},
    {id:"营销活动", label:"营销活动", badge:"DEALS"},
    {id:"店铺广告", label:"店铺广告"},
    {id:"智能营销", label:"智能营销"},
    {id:"店铺页面", label:"店铺页面", badge:"NEW"},
  ];
  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>
      <div style={{width:178,background:"#fff",borderRight:"1px solid #ebebeb",flexShrink:0,paddingTop:4,overflowY:"auto"}}>
        {subNavItems.map(n=>(
          <div key={n.id} onClick={()=>setSubNav(n.id)} style={{padding:"9px 16px",fontSize:13,cursor:"pointer",color:subNav===n.id?"#21c3bc":"#333",background:subNav===n.id?"#f0fffe":"transparent",borderLeft:subNav===n.id?"3px solid #21c3bc":"3px solid transparent",fontWeight:subNav===n.id?500:400,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span>{n.label}</span>
            {n.badge==="NEW"&&<span style={{background:"#ff4d4f",color:"#fff",borderRadius:3,padding:"1px 5px",fontSize:10,fontWeight:700}}>NEW</span>}
            {n.badge==="DEALS"&&<span style={{background:"#ff4d4f",color:"#fff",borderRadius:3,padding:"1px 5px",fontSize:10,fontWeight:700}}>DEALS<br/>FOR YOU</span>}
          </div>
        ))}
      </div>
      <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
        {subNav==="店铺广告"&&<AdsDashboard/>}
        {subNav==="促销活动"&&<PromotionsPage/>}
        {subNav!=="店铺广告"&&subNav!=="促销活动"&&(
          <div style={{padding:24}}><div style={{background:"#fff",borderRadius:6,padding:"60px 40px",textAlign:"center",color:"#999",fontSize:13}}>页面建设中</div></div>
        )}
      </div>
    </div>
  );
}

function AdsDashboard() {
  const [balance, setBalance] = useState("0.00");
  const [editingBalance, setEditingBalance] = useState(false);
  const [balVal, setBalVal] = useState("0.00");
  return (
    <div style={{padding:"20px 24px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div style={{display:"flex",alignItems:"center",gap:12}}>
          <h2 style={{margin:0,fontSize:20,fontWeight:600,color:"#111"}}>广告数据面板</h2>
          <span style={{fontSize:12,color:"#21c3bc",cursor:"pointer"}}>📱 随时随地掌握最新动态。下载应用。</span>
        </div>
        <button style={{background:"#21c3bc",border:"none",borderRadius:6,padding:"8px 18px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500}}>创建 GMV Max 广告</button>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"260px 1fr",gap:16}}>
        {/* 左侧导航 */}
        <div style={{background:"#fff",borderRadius:6,overflow:"hidden"}}>
          <div style={{padding:"14px 16px",borderBottom:"1px solid #f0f0f0",fontWeight:600,fontSize:14,color:"#111",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
            <span>GMV Max</span>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>
          </div>
          {[{icon:"🎯",label:"活动",active:true},{icon:"🎨",label:"创意作品",badge:"新增"},{icon:"📊",label:"账号"}].map(item=>(
            <div key={item.label} style={{padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer",borderLeft:item.active?"3px solid #21c3bc":"3px solid transparent",background:item.active?"#f0fffe":"transparent",color:item.active?"#21c3bc":"#333",fontSize:13}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}><span>{item.icon}</span><span>{item.label}</span></div>
              {item.badge&&<span style={{background:"#21c3bc",color:"#fff",borderRadius:3,padding:"1px 6px",fontSize:10,fontWeight:600}}>{item.badge}</span>}
            </div>
          ))}
        </div>
        {/* 右侧内容 */}
        <div style={{display:"flex",flexDirection:"column",gap:12}}>
          {/* 余额耗尽提示 */}
          <div style={{background:"#fff",borderRadius:6,padding:"14px 16px",borderLeft:"4px solid #ff4d4f",display:"flex",alignItems:"flex-start",gap:10}}>
            <span style={{color:"#ff4d4f",fontSize:16,flexShrink:0}}>⊗</span>
            <div>
              <div style={{fontWeight:600,fontSize:13,color:"#111",marginBottom:4}}>余额已耗尽</div>
              <div style={{fontSize:12,color:"#555",marginBottom:6}}>你的账号余额已耗尽，充值以免竞价广告暂停。</div>
              <span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>充值</span>
            </div>
          </div>
          {/* 余额行 */}
          <div style={{background:"#fff",borderRadius:6,padding:"14px 16px",display:"flex",alignItems:"center",gap:12}}>
            <span style={{fontSize:13,color:"#555"}}>可用余额：</span>
            {editingBalance
              ? <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                  <input value={balVal} autoFocus onChange={e=>setBalVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setBalance(balVal);setEditingBalance(false);}if(e.key==="Escape")setEditingBalance(false);}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"2px 6px",fontSize:13,width:80,outline:"none"}}/>
                  <button onClick={()=>{setBalance(balVal);setEditingBalance(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"2px 6px",fontSize:11,cursor:"pointer"}}>✓</button>
                </span>
              : <span onDoubleClick={()=>{setBalVal(balance);setEditingBalance(true);}} style={{fontWeight:600,fontSize:13,color:"#111",cursor:"pointer",borderBottom:"none"}}>{balance} USD</span>
            }
            <span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999",cursor:"pointer"}}>?</span>
            <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"5px 14px",color:"#fff",fontSize:12,cursor:"pointer",fontWeight:500}}>充值</button>
            <span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>支付明细</span>
          </div>
          {/* 数据卡片 */}
          <div style={{background:"#fff",borderRadius:6,padding:"16px"}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
              <span style={{fontWeight:600,fontSize:14,color:"#111"}}>Saintly Ornament</span>
              <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#888"}}>
                <span>(UTC-09:00) 阿拉斯加标准时间</span>
                <span style={{border:"1px solid #ddd",borderRadius:3,padding:"3px 10px",cursor:"pointer"}}>2026-06-06 - 2026-06-13 📅</span>
                <span style={{cursor:"pointer"}}>⬇</span>
              </div>
            </div>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:6}}>概览</div>
            <div style={{fontSize:12,color:"#888",marginBottom:14}}>无论是通过 TikTok 广告管理平台还是商家中心（桌面版或移动应用）创建，所有 GMV Max 广告都能查看报告。</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:8,marginBottom:16}}>
              {[
                {label:"成本",value:"0.00 USD",sub:"较近 7 日 • -100.00%",checked:true,subColor:"#ff4d4f"},
                {label:"SKU 订单...",value:"0",sub:"较近 7 日 -",checked:true,subColor:"#888"},
                {label:"平均下单...",value:"0.00 USD",sub:"较近 7 日 -",checked:false,subColor:"#888"},
                {label:"总收入 (...",value:"0.00 USD",sub:"较近 7 日 -",checked:false,subColor:"#888"},
                {label:"投资回报...",value:"0.00",sub:"较近 7 日 -",checked:false,subColor:"#888"},
              ].map(m=>(
                <div key={m.label} style={{border:m.checked?"2px solid #21c3bc":"1px solid #f0f0f0",borderRadius:6,padding:"12px",background:m.checked?"#f0fffe":"#fff"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:8}}>
                    <span style={{fontSize:12,color:"#888"}}>{m.label}</span>
                    <input type="checkbox" defaultChecked={m.checked} style={{accentColor:"#21c3bc"}}/>
                  </div>
                  <div style={{fontSize:18,fontWeight:700,color:"#111",marginBottom:4}}>{m.value}</div>
                  <div style={{fontSize:11,color:m.subColor}}>{m.sub}</div>
                </div>
              ))}
            </div>
            {/* 图例 */}
            <div style={{display:"flex",alignItems:"center",gap:16,fontSize:12,color:"#888",marginBottom:8}}>
              <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:8,height:8,borderRadius:"50%",background:"#21c3bc",display:"inline-block"}}/> 成本</span>
              <span style={{display:"flex",alignItems:"center",gap:4}}><span style={{width:8,height:8,borderRadius:"50%",background:"#faad14",display:"inline-block"}}/> SKU 订单数（当前店铺）</span>
            </div>
            {/* 折线图占位 */}
            <div style={{height:120,position:"relative",borderBottom:"1px solid #f0f0f0"}}>
              <div style={{position:"absolute",bottom:0,left:0,right:0,display:"flex",justifyContent:"space-between",fontSize:11,color:"#bbb",padding:"4px 0"}}>
                {["Jun 6","Jun 7","Jun 8","Jun 9","Jun 10","Jun 11","Jun 12","Jun 13"].map(d=><span key={d}>{d}</span>)}
              </div>
            </div>
          </div>
          {/* 广告计划列表 */}
          <div style={{background:"#fff",borderRadius:6,padding:"16px"}}>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:4}}>广告计划列表</div>
            <div style={{fontSize:12,color:"#888",marginBottom:14}}>无论是通过 TikTok 广告管理平台还是商家中心（桌面版或移动应用）创建，所有 GMV Max 广告支持推广系列管理和报告</div>
            <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",marginBottom:14}}>
              {["商品 GMV Max","直播 GMV Max"].map((t,i)=>(
                <div key={t} style={{padding:"8px 16px 8px 0",marginRight:20,fontSize:13,cursor:"pointer",color:i===0?"#21c3bc":"#555",borderBottom:i===0?"2px solid #21c3bc":"2px solid transparent",fontWeight:i===0?500:400}}>{t}</div>
              ))}
            </div>
            <div style={{display:"flex",gap:8,marginBottom:12}}>
              <div style={{flex:1,border:"1px solid #ddd",borderRadius:4,padding:"6px 12px",display:"flex",alignItems:"center",gap:6,color:"#bbb",fontSize:13}}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
                搜索活动或商品 ID
              </div>
              <div style={{border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:6,minWidth:80}}>
                状态 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg>
              </div>
              <div style={{display:"flex",gap:4}}>
                <button style={{background:"none",border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",cursor:"pointer"}}>⊞</button>
                <button style={{background:"none",border:"1px solid #ddd",borderRadius:4,padding:"6px 10px",cursor:"pointer"}}>🗑</button>
              </div>
            </div>
            <div style={{border:"1px solid #f0f0f0",borderRadius:4,overflow:"hidden"}}>
              <div style={{display:"grid",gridTemplateColumns:"40px 2fr 1fr 1fr 1fr 1fr",padding:"10px 14px",background:"#fafafa",fontSize:12,color:"#888",fontWeight:500,borderBottom:"1px solid #f0f0f0"}}>
                <span>开/关</span><span>广告计划名称 ↕</span><span>状态</span><span>广告计划预算</span><span>成本 ↓</span><span>ROI 保护</span>
              </div>
              {[
                {on:true,name:"商品 GMV Max_总收入_Saintly Orna...",status:"未投放",statusSub:"余额不足",budget:"200.00 USD",budgetSub:"日预算：200.00 USD",cost:"0.00 USD",roi:"符合投资回报资格",statusColor:"#888"},
                {on:false,name:"商品 GMV Max_总收入_Saintly Orna...",status:"已暂停",statusSub:"",budget:"200.00 USD",budgetSub:"日预算：200.00 USD",cost:"0.00 USD",roi:"符合投资回报资格",statusColor:"#888"},
              ].map((row,i)=>(
                <div key={i} style={{display:"grid",gridTemplateColumns:"40px 2fr 1fr 1fr 1fr 1fr",padding:"12px 14px",borderBottom:i===0?"1px solid #f5f5f5":"none",alignItems:"center"}}>
                  <div style={{width:32,height:18,borderRadius:9,background:row.on?"#21c3bc":"#ddd",position:"relative",cursor:"pointer"}}>
                    <div style={{position:"absolute",top:2,left:row.on?16:2,width:14,height:14,borderRadius:"50%",background:"#fff",transition:"left 0.2s"}}/>
                  </div>
                  <div style={{fontSize:13,color:"#333",paddingRight:10}}>{row.name}</div>
                  <div>
                    <div style={{display:"flex",alignItems:"center",gap:4,fontSize:13}}>
                      <div style={{width:6,height:6,borderRadius:"50%",background:row.on?"#21c3bc":"#ff4d4f",flexShrink:0}}/>
                      <span style={{color:"#333"}}>{row.status}</span>
                    </div>
                    {row.statusSub&&<div style={{fontSize:11,color:"#888",marginTop:2}}>{row.statusSub}</div>}
                  </div>
                  <div><div style={{fontSize:13,color:"#333"}}>{row.budget}</div><div style={{fontSize:11,color:"#888"}}>{row.budgetSub}</div></div>
                  <div style={{fontSize:13,color:"#333"}}>{row.cost}</div>
                  <div style={{display:"flex",alignItems:"center",gap:4}}>
                    <div style={{width:16,height:16,borderRadius:"50%",background:"#21c3bc",display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                    <span style={{fontSize:12,color:"#333"}}>{row.roi}</span>
                  </div>
                </div>
              ))}
            </div>
            <div style={{marginTop:12,fontSize:12,color:"#888"}}>
              如要管理在 TikTok 广告管理平台上创建的广告，请前往 <span style={{color:"#21c3bc",cursor:"pointer"}}>TikTok 广告管理平台</span>。
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function PromotionsPage() {
  const [activeTab, setActiveTab] = useState("概览");
  const tabs = ["概览","管理你的促销活动","价格监控"];
  const [gmv, setGmv] = useState("0.00");
  const [editGmv, setEditGmv] = useState(false);
  const [gmvVal, setGmvVal] = useState("0.00");
  return (
    <div style={{padding:"20px 24px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <h2 style={{margin:0,fontSize:20,fontWeight:600,color:"#111"}}>促销活动</h2>
        <div style={{display:"flex",gap:8}}>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"7px 16px",fontSize:13,cursor:"pointer",color:"#333"}}>了解更多</button>
          <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"7px 16px",fontSize:13,cursor:"pointer",color:"#fff",fontWeight:500}}>创建促销活动</button>
        </div>
      </div>
      {/* Tab */}
      <div style={{display:"flex",borderBottom:"1px solid #f0f0f0",marginBottom:16,background:"#fff",borderRadius:"6px 6px 0 0",padding:"0 16px"}}>
        {tabs.map((t,i)=><div key={t} onClick={()=>setActiveTab(t)} style={{padding:"12px 16px",fontSize:13,cursor:"pointer",color:activeTab===t?"#21c3bc":"#555",borderBottom:activeTab===t?"2px solid #21c3bc":"2px solid transparent",fontWeight:activeTab===t?500:400}}>{t}</div>)}
      </div>
      {/* 表现 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <span style={{fontWeight:600,fontSize:14,color:"#111"}}>表现</span>
          <div style={{display:"flex",alignItems:"center",gap:8,fontSize:12,color:"#888"}}>
            <span>最近 7 天：2026/06/06 - 2026/06/12</span>
            <span style={{color:"#21c3bc",cursor:"pointer"}}>查看更多数据 &gt;</span>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px"}}>
            <div style={{fontSize:12,color:"#888",marginBottom:8}}>促销活动 GMV</div>
            <div style={{fontSize:24,fontWeight:700,color:"#111",marginBottom:8}}>
              $
              {editGmv
                ? <span style={{display:"inline-flex",alignItems:"center",gap:4}}>
                    <input value={gmvVal} autoFocus onChange={e=>setGmvVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter"){setGmv(gmvVal);setEditGmv(false);}}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"1px 5px",fontSize:20,fontWeight:700,width:100,outline:"none"}}/>
                    <button onClick={()=>{setGmv(gmvVal);setEditGmv(false);}} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"2px 6px",fontSize:11,cursor:"pointer"}}>✓</button>
                  </span>
                : <span onDoubleClick={()=>{setGmvVal(gmv);setEditGmv(true);}} style={{cursor:"default",borderBottom:"none"}}>{gmv}</span>
              }
            </div>
            <div style={{height:60,background:"linear-gradient(to top,#e6fff9,transparent)",borderRadius:4}}/>
          </div>
          <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",textAlign:"center"}}>
            <div style={{fontSize:13,color:"#888",marginBottom:8}}>在此日期范围内未找到促销活动。请尝试选择其他时间段</div>
            <div style={{fontSize:13,color:"#888"}}>或<span style={{color:"#21c3bc",cursor:"pointer"}}>创建新促销活动</span>。</div>
          </div>
        </div>
      </div>
      {/* 推荐配置 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:12}}>
        <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:4}}>推荐的促销活动配置</div>
        <div style={{fontSize:12,color:"#888",marginBottom:14}}>快速试用根据其他商家成功经验预填写的促销活动设置。</div>
        <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px",display:"flex",alignItems:"center",gap:20}}>
          <div style={{background:"#fff",border:"2px dashed #ddd",borderRadius:6,padding:"12px 16px",minWidth:120}}>
            <div style={{fontSize:10,color:"#888",textAlign:"center",marginBottom:8}}>Coupons</div>
            <div style={{background:"linear-gradient(135deg,#ff6b6b,#ee5a24)",borderRadius:4,padding:"8px 10px",display:"flex",alignItems:"center",gap:8}}>
              <div style={{background:"rgba(255,255,255,0.9)",borderRadius:3,padding:"4px 6px",textAlign:"center"}}>
                <div style={{fontWeight:700,fontSize:14,color:"#ee5a24"}}>$5</div>
                <div style={{fontSize:9,color:"#ee5a24"}}>优</div>
              </div>
              <div style={{fontSize:10,color:"#fff",flex:1}}>适用于金额满 $10 的订单</div>
              <button style={{background:"#fff",border:"none",borderRadius:3,padding:"3px 6px",fontSize:10,color:"#ee5a24",cursor:"pointer",fontWeight:600}}>Claim</button>
            </div>
          </div>
          <div style={{flex:1}}>
            <div style={{fontWeight:500,fontSize:13,color:"#111",marginBottom:6}}>利用优惠券将流量转化为销量。</div>
            <div style={{fontSize:12,color:"#21c3bc",marginBottom:6,cursor:"pointer"}}>↗ 有类似促销活动的 118200 位商家促销商品的 GMV 平均增长了 90%。</div>
            <div style={{fontSize:12,color:"#555",marginBottom:12}}>为订单金额超过 $10.00 的客户提供 $5.00 折扣，增加订单量和销售额。</div>
            <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"7px 18px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500}}>创建</button>
          </div>
        </div>
      </div>
      {/* 探索工具 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px"}}>
        <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:4}}>探索所有促销工具</div>
        <div style={{borderBottom:"1px solid #f0f0f0",paddingBottom:12,marginBottom:12}}>
          <div style={{fontWeight:500,fontSize:13,color:"#111",marginBottom:3}}>降价</div>
          <div style={{fontSize:12,color:"#888"}}>设置商品折扣，以吸引客户并提高转化率。</div>
        </div>
      </div>
    </div>
  );
}

// ── 物流页面 ──────────────────────────────────────────────────────────────────
function LogisticsPage() {
  const [subNav, setSubNav] = useState("概览");
  const subNavItems = ["概览","仓库管理","履约设置","物流服务","Fulfilled by TikTok（FBT）"];

  return (
    <div style={{display:"flex",height:"100%",overflow:"hidden"}}>
      {/* 二级导航 */}
      <div style={{width:178,background:"#fff",borderRight:"1px solid #ebebeb",flexShrink:0,paddingTop:4,overflowY:"auto"}}>
        {subNavItems.map(n=>(
          <div key={n} onClick={()=>setSubNav(n)} style={{padding:"9px 16px",fontSize:13,cursor:"pointer",color:subNav===n?"#21c3bc":"#333",background:subNav===n?"#f0fffe":"transparent",borderLeft:subNav===n?"3px solid #21c3bc":"3px solid transparent",fontWeight:subNav===n?500:400,lineHeight:1.4}}>{n}</div>
        ))}
      </div>

      {/* 主内容 */}
      <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
        {subNav==="概览" && <LogisticsOverview/>}
        {subNav==="仓库管理" && <WarehousePage/>}
        {subNav==="履约设置" && <FulfillmentSettings/>}
        {subNav==="物流服务" && <LogisticsService/>}
        {subNav==="Fulfilled by TikTok（FBT）" && <FBTPage/>}
      </div>
    </div>
  );
}

function LogisticsOverview() {
  const [pkgCount, setPkgCount] = useState("2");
  const [deliveryRate, setDeliveryRate] = useState("0.0");
  const [editing, setEditing] = useState(null);
  const [val, setVal] = useState("");

  const startEdit = (field, v) => { setEditing(field); setVal(v); };
  const saveEdit = (field, setter) => { setter(val); setEditing(null); };

  const EF = ({field, value, setter, width=60}) => editing===field
    ? <span style={{display:"inline-flex",alignItems:"center",gap:2}}>
        <input autoFocus value={val} onChange={e=>setVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")saveEdit(field,setter);if(e.key==="Escape")setEditing(null);}} style={{border:"1px solid #21c3bc",borderRadius:3,padding:"1px 5px",fontSize:"inherit",fontWeight:"inherit",width,outline:"none"}}/>
        <button onClick={()=>saveEdit(field,setter)} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:2,padding:"1px 5px",fontSize:11,cursor:"pointer"}}>✓</button>
      </span>
    : <span onClick={()=>startEdit(field,value)} style={{cursor:"default",borderBottom:"none"}} title="双击编辑">{value}</span>;

  return (
    <div style={{padding:"20px 24px"}}>
      {/* CBT横幅 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:16,position:"relative"}}>
        <div style={{position:"absolute",top:12,right:16,cursor:"pointer",color:"#bbb",fontSize:16}}>×</div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
          <div>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:8}}>Collection by TikTok (CBT) 全新物流权益</div>
            <div style={{fontSize:12,color:"#555",lineHeight:1.8,marginBottom:4}}>• <strong>限时优惠：</strong>日均 CBT 包裹超过 200 个的店铺，Zone 1-4 包裹可享每单立减 $0.50</div>
            <div style={{fontSize:12,color:"#555",lineHeight:1.8,marginBottom:4}}>• <strong>揽收网络升级：</strong>新增伊利诺伊和佐治亚部分城市，覆盖全美八大核心区域，支持每周 7 天免费上门揽收</div>
            <div style={{fontSize:12,color:"#555",lineHeight:1.8,marginBottom:10}}>• <strong>零门槛报名：</strong>海外仓已在发 CBT？零门槛报名特权现已解锁！<span style={{color:"#21c3bc",cursor:"pointer"}}>了解更多</span></div>
            <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"7px 16px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500}}>立即加入</button>
          </div>
          <div style={{fontSize:48,marginLeft:20,flexShrink:0}}>🚚</div>
        </div>
      </div>

      {/* 物流表现 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
          <div style={{fontWeight:600,fontSize:15,color:"#111"}}>物流表现</div>
          <div style={{fontSize:12,color:"#888"}}>上次更新时间：2026/06/11</div>
        </div>
        {/* 标签 */}
        <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",marginBottom:16}}>
          {["全部","Fulfilled by TikTok","平台发货"].map((t,i)=>(
            <div key={t} style={{padding:"8px 16px",fontSize:13,cursor:"pointer",color:i===0?"#21c3bc":"#555",borderBottom:i===0?"2px solid #21c3bc":"2px solid transparent",fontWeight:i===0?500:400}}>{t}</div>
          ))}
        </div>
        {/* 指标 */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:12,marginBottom:14}}>
          {[
            {label:"包裹数量",hint:true,value:<EF field="pkg" value={pkgCount} setter={setPkgCount} width={50}/>,sub:null},
            {label:"三日送达率",hint:true,value:<><EF field="delivery" value={deliveryRate} setter={setDeliveryRate} width={50}/><span style={{marginLeft:2}}>%</span></>,sub:null},
            {label:"延迟发货率",hint:true,value:<span style={{color:"#333"}}>-  %</span>,sub:"FBT 订单不计入"},
            {label:"1 天发货率",hint:true,value:<span style={{color:"#333"}}>-  %</span>,sub:null},
          ].map(m=>(
            <div key={m.label} style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"14px 16px"}}>
              <div style={{fontSize:12,color:"#888",marginBottom:8,display:"flex",alignItems:"center",gap:3}}>{m.label}{m.hint&&<span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #ddd",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#bbb"}}>?</span>}</div>
              <div style={{fontSize:22,fontWeight:700,color:"#111"}}>{m.value}</div>
              {m.sub&&<div style={{fontSize:11,color:"#999",marginTop:4}}>{m.sub}</div>}
            </div>
          ))}
        </div>
        <div style={{textAlign:"center",color:"#21c3bc",fontSize:13,cursor:"pointer"}}>显示更多 ▾</div>
      </div>

      {/* FBT推广 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:16}}>
        <div style={{display:"flex",alignItems:"flex-start",gap:8,marginBottom:12}}>
          <span style={{color:"#21c3bc",fontSize:18}}>✦</span>
          <div><strong style={{fontSize:14}}>继续使用 Fulfilled by TikTok，享受加码福利</strong></div>
        </div>
        <div style={{fontSize:12,color:"#555",lineHeight:2,marginLeft:26}}>
          <div>• <strong>节约成本：</strong>伴随业务增长和包裹数量增加，可享受更优惠的履约费折扣。<span style={{color:"#21c3bc",cursor:"pointer"}}>了解更多</span></div>
          <div>• <strong>提升履约表现：</strong>FBT 订单不计入会影响你店铺体验分（SPS）的指标，包括延迟发货率、按时送达率、有效退款率和商费取消率。</div>
        </div>
        <div style={{marginLeft:26,marginTop:6}}><span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>展开 ▾</span></div>
      </div>

      {/* 物流方式对比 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:16}}>
        <div style={{fontWeight:600,fontSize:15,color:"#111",marginBottom:16}}>物流方式对比</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",gap:0}}>
          <div/>
          {[
            {name:"TikTok FBT",sub:"TikTok Shop 的全流程履约解决方案"},
            {name:"TikTok 揽收",sub:"使用升级版 TikTok 物流服务和上门取件服务"},
            {name:"TikTok 物流",sub:"通过 TikTok Shop 的合作承运商发货"},
          ].map(c=>(
            <div key={c.name} style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px",margin:"0 6px",textAlign:"center"}}>
              <div style={{fontWeight:700,fontSize:14,color:"#111",marginBottom:6}}>{c.name}</div>
              <div style={{fontSize:11,color:"#888",marginBottom:12,lineHeight:1.5}}>{c.sub}</div>
              <button style={{background:"#f5f5f5",border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:12,cursor:"pointer",color:"#555",width:"100%"}}>查看详情</button>
            </div>
          ))}
        </div>
        <div style={{marginTop:16}}>
          {[
            {label:"商品曝光度",vals:[true,true,true]},
            {label:"显示配送时效标签",vals:[true,true,true]},
            {label:"已推荐给达人",vals:[true,false,false]},
            {label:"提高曝光度",vals:[true,false,false]},
            {label:"体验指标保障",vals:[true,true,true]},
            {label:"履约指标保障",vals:[true,true,true]},
          ].map(r=>(
            <div key={r.label} style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",padding:"10px 0",borderBottom:"1px solid #f5f5f5",alignItems:"center"}}>
              <div style={{fontSize:13,color:"#555"}}>{r.label}</div>
              {r.vals.map((v,i)=>(
                <div key={i} style={{textAlign:"center"}}>
                  <span style={{fontSize:18,color:v?"#52c41a":"#ff4d4f"}}>{v?"✓":"✗"}</span>
                </div>
              ))}
            </div>
          ))}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr 1fr",padding:"10px 0",alignItems:"center"}}>
            <div style={{fontSize:13,color:"#555"}}>费用</div>
            {["仓储和履约费折扣","使用 TikTok 物流服务最高可享 30% 折扣","最高 20% 折扣"].map((t,i)=>(
              <div key={i} style={{textAlign:"center",fontSize:12,color:"#333"}}>{t}</div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function WarehousePage() {
  const [warehouses, setWarehouses] = useState([
    {id:1, name:"X091新泽西仓", code:"7633577523569461010", addr:"13 Sylvan Ave", city:"Metuchen, Middlesex, 新泽西, 美国", zip:"邮政编码: 08840", phone:"(+1)9736157295", contact:"Rui Li", isDefault:true},
    {id:2, name:"晃晓斌的仓库", code:"7631433025490814727", addr:"7222 S PEEK RD APT 2110", city:"Richmond, Fort Bend, 得克萨斯, 美国", zip:"邮政编码: 77407", phone:"(+1)9177754910", contact:"晃晓斌", isDefault:false},
  ]);
  const [returnWarehouses, setReturnWarehouses] = useState([
    {id:1, name:"X091新泽西仓", code:"7633514526948493074", addr:"13 Sylvan Ave", city:"Metuchen, Middlesex, 新泽西, 美国", zip:"邮政编码: 08840", phone:"(+1)9736157295", contact:"Rui Li"},
    {id:2, name:"晃晓斌的仓库", code:"7631438429872015112", addr:"7222 S PEEK RD APT 2110", city:"Richmond, Fort Bend, 得克萨斯, 美国", zip:"邮政编码: 77407", phone:"(+1)9177754910", contact:"晃晓斌"},
  ]);

  const WarehouseCard = ({w, showDefault, showDelete, onSetDefault}) => (
    <div style={{padding:"16px 20px",borderBottom:"1px solid #f0f0f0"}}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 2fr 1fr 1fr",gap:10,alignItems:"flex-start"}}>
        <div>
          <div style={{fontWeight:600,fontSize:13,color:"#111",marginBottom:3}}>{w.name}</div>
          <div style={{fontSize:11,color:"#888",marginBottom:8}}>仓库编号: {w.code}</div>
          <div style={{display:"flex",gap:6}}>
            {w.isDefault&&<span style={{background:"#e6fff9",color:"#21c3bc",border:"1px solid #21c3bc",borderRadius:3,padding:"2px 8px",fontSize:11}}>默认仓库</span>}
            <span style={{background:"#e6fff9",color:"#21c3bc",border:"1px solid #21c3bc",borderRadius:3,padding:"2px 8px",fontSize:11}}>独立库存</span>
          </div>
        </div>
        <div style={{fontSize:12,color:"#555",lineHeight:1.8}}>
          <div>{w.addr}</div>
          <div>{w.city}</div>
          <div>{w.zip}</div>
          <div>{w.phone} &nbsp; {w.contact}</div>
        </div>
        <div><span style={{background:"#e6fff9",color:"#21c3bc",border:"1px solid #b7eb8f",borderRadius:3,padding:"2px 8px",fontSize:11,fontWeight:500}}>已启用</span></div>
        <div style={{fontSize:13}}>
          <div style={{color:"#21c3bc",cursor:"pointer",marginBottom:4}}>编辑</div>
          {!w.isDefault&&onSetDefault&&<div style={{color:"#21c3bc",cursor:"pointer"}} onClick={onSetDefault}>设为默认</div>}
          {showDelete&&<div style={{color:"#ff4d4f",cursor:"pointer",marginTop:4}}>删除</div>}
        </div>
      </div>
    </div>
  );

  return (
    <div style={{padding:"20px 24px"}}>
      <h2 style={{margin:"0 0 16px",fontSize:20,fontWeight:600,color:"#111"}}>仓库设置</h2>

      {/* 美国仓库 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:16}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
          <div style={{fontWeight:600,fontSize:14,color:"#111"}}>美国仓库</div>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#333",display:"flex",alignItems:"center",gap:6}}><span>⊕</span>所有仓库</button>
        </div>
        <div style={{fontSize:12,color:"#888",marginBottom:12}}>切换设置即可查看其他国家/地区的仓库。</div>
        <div style={{display:"flex",gap:8,marginBottom:16}}>
          <div style={{flex:1,border:"1px solid #ddd",borderRadius:4,padding:"7px 12px",display:"flex",alignItems:"center",gap:6,color:"#bbb",fontSize:13}}><span>🔍</span>搜索</div>
          <div style={{border:"1px solid #ddd",borderRadius:4,padding:"7px 14px",fontSize:13,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:6,minWidth:140}}>仓库位置 <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg></div>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"7px 14px",fontSize:13,cursor:"pointer",color:"#555",display:"flex",alignItems:"center",gap:5}}><span>↻</span>重置</button>
        </div>

        {/* 所有发货仓 */}
        <div style={{marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <div style={{display:"flex",alignItems:"center",gap:6,fontWeight:600,fontSize:14,color:"#111"}}><span>🏠</span>所有发货仓<span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #ddd",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#bbb"}}>?</span></div>
            <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#333",display:"flex",alignItems:"center",gap:5}}>添加仓库 <svg width="8" height="5" viewBox="0 0 8 5" fill="#555"><path d="M0 0l4 5 4-5z"/></svg></button>
          </div>
          <div style={{background:"#fffbe6",border:"1px solid #ffe58f",borderRadius:4,padding:"10px 14px",marginBottom:12,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
            <span style={{fontSize:12,color:"#555"}}>ℹ️ 如果你使用的是第三方仓储服务，请填写主仓库的地址。</span>
            <span style={{cursor:"pointer",color:"#bbb",fontSize:14}}>×</span>
          </div>
          <div style={{border:"1px solid #f0f0f0",borderRadius:6,overflow:"hidden"}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 2fr 1fr 1fr",padding:"10px 20px",background:"#fafafa",borderBottom:"1px solid #f0f0f0",fontSize:12,color:"#888",fontWeight:500}}>
              <span>仓库名/编码</span><span>地址</span><span>状态</span><span>操作</span>
            </div>
            {warehouses.map((w,i)=><WarehouseCard key={w.id} w={w} showDefault onSetDefault={()=>{setWarehouses(ws=>ws.map((ww,ii)=>({...ww,isDefault:ii===i})));}}/>)}
          </div>
        </div>

        <div style={{fontSize:12,color:"#555",padding:"10px 0"}}>
          Fulfilled by TikTok（FBT）可助你简化物流和履约流程。<span style={{color:"#21c3bc",cursor:"pointer"}}>详细了解 FBT</span>
        </div>
      </div>

      {/* 退货仓库 */}
      <div style={{background:"#fff",borderRadius:6,overflow:"hidden"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"16px 20px",borderBottom:"1px solid #f0f0f0"}}>
          <div style={{fontWeight:600,fontSize:15,color:"#111"}}>退货仓库</div>
          <button style={{background:"#fff",border:"1px solid #ddd",borderRadius:4,padding:"6px 14px",fontSize:13,cursor:"pointer",color:"#333",display:"flex",alignItems:"center",gap:5}}>添加仓库 <svg width="8" height="5" viewBox="0 0 8 5" fill="#555"><path d="M0 0l4 5 4-5z"/></svg></button>
        </div>
        <div style={{border:"1px solid #f0f0f0",margin:"16px 20px",borderRadius:6,overflow:"hidden"}}>
          <div style={{display:"grid",gridTemplateColumns:"1fr 2fr 1fr 1fr",padding:"10px 20px",background:"#fafafa",borderBottom:"1px solid #f0f0f0",fontSize:12,color:"#888",fontWeight:500}}>
            <span>仓库名/编码</span><span>地址</span><span>状态</span><span>操作</span>
          </div>
          {returnWarehouses.map(w=>(
            <div key={w.id} style={{padding:"16px 20px",borderBottom:"1px solid #f0f0f0"}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 2fr 1fr 1fr",gap:10,alignItems:"flex-start"}}>
                <div>
                  <div style={{fontWeight:600,fontSize:13,color:"#111",marginBottom:3}}>{w.name}</div>
                  <div style={{fontSize:11,color:"#888"}}>仓库编号: {w.code}</div>
                </div>
                <div style={{fontSize:12,color:"#555",lineHeight:1.8}}><div>{w.addr}</div><div>{w.city}</div><div>{w.zip}</div><div>{w.phone} &nbsp; {w.contact}</div></div>
                <div><span style={{background:"#e6fff9",color:"#21c3bc",border:"1px solid #b7eb8f",borderRadius:3,padding:"2px 8px",fontSize:11,fontWeight:500}}>已启用</span></div>
                <div style={{fontSize:13}}><div style={{color:"#21c3bc",cursor:"pointer",marginBottom:4}}>编辑</div><div style={{color:"#ff4d4f",cursor:"pointer"}}>删除</div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function FulfillmentSettings() {
  return (
    <div style={{padding:"20px 24px"}}>
      <h2 style={{margin:"0 0 16px",fontSize:20,fontWeight:600,color:"#111"}}>履约设置</h2>
      {/* 标签 */}
      <div style={{display:"flex",gap:0,borderBottom:"1px solid #f0f0f0",marginBottom:16,background:"#fff",borderRadius:"6px 6px 0 0",padding:"0 16px"}}>
        {["履约设置","管理物流"].map((t,i)=>(
          <div key={t} style={{padding:"12px 16px",fontSize:13,cursor:"pointer",color:i===0?"#21c3bc":"#555",borderBottom:i===0?"2px solid #21c3bc":"2px solid transparent",fontWeight:i===0?500:400}}>{t}</div>
        ))}
      </div>
      {/* 保障计划横幅 */}
      <div style={{background:"#fff",borderRadius:6,padding:"16px 20px",marginBottom:12,position:"relative"}}>
        <div style={{position:"absolute",top:12,right:16,cursor:"pointer",color:"#bbb",fontSize:16}}>×</div>
        <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:6}}>全新物流保障计划，为你的包裹提供全方位保护</div>
        <div style={{fontSize:12,color:"#555",marginBottom:10}}>减少因物流问题造成的损失。加入我们的全新物流保障计划，运输途中任何包裹丢失或损坏均可获得全额赔付。</div>
        <span style={{color:"#21c3bc",fontSize:13,cursor:"pointer"}}>立即报名</span>
      </div>
      {/* 设置列表 */}
      <div style={{background:"#fff",borderRadius:6,overflow:"hidden"}}>
        {[
          {icon:"📄",title:"面单创建和打印",sub:"选择创建和打印物流面单的首选方式",action:"发货后打印面单",actionIcon:true},
          {icon:"🖨",title:"单据格式选项",sub:"设置物流单据的默认尺寸和格式",action:"物流面单 (A6), 装箱单 (A6)",actionIcon:true},
          {icon:"📦",title:"包裹设置",sub:"添加可用于 TikTok 物流订单的包裹",action:"设置",actionBtn:true,actionColor:"#21c3bc"},
          {icon:"🛡",title:"物流保障设置",sub:"加入物流保障计划，让你的店铺不再因包裹丢失或损坏而蒙受损失",action:"编辑",actionIcon:true},
          {icon:"📋",title:"合并订单，节省运费",sub:"自动合并由同一客户所下的订单，并为客户提供运费折扣",action:"已停用",actionIcon:true},
        ].map((item,i)=>(
          <div key={item.title} style={{display:"flex",alignItems:"center",padding:"16px 20px",borderBottom:i<4?"1px solid #f0f0f0":"none"}}>
            <div style={{width:40,height:40,background:"#f5f5f5",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20,flexShrink:0,marginRight:16}}>{item.icon}</div>
            <div style={{flex:1}}>
              <div style={{fontWeight:500,fontSize:14,color:"#111",marginBottom:3}}>{item.title}</div>
              <div style={{fontSize:12,color:"#888"}}>{item.sub}</div>
            </div>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              {item.actionBtn
                ? <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"7px 16px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500}}>{item.action}</button>
                : <span style={{fontSize:13,color:"#555"}}>{item.action}</span>
              }
              {item.actionIcon&&!item.actionBtn&&<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>}
            </div>
          </div>
        ))}
      </div>
      <div style={{fontSize:12,color:"#888",marginTop:12,padding:"0 4px"}}>如需查看取消和退货设置，请前往[退货设置] (/order/reverse-setting?tab=return)</div>
    </div>
  );
}

function LogisticsService() {
  const [activeWarehouse, setActiveWarehouse] = useState("X091新泽西仓");
  const warehouses = ["X091新泽西仓","晃晓斌的仓库"];
  return (
    <div style={{padding:"20px 24px"}}>
      <h2 style={{margin:"0 0 16px",fontSize:20,fontWeight:600,color:"#111"}}>物流服务</h2>
      {/* 提示横幅 */}
      <div style={{background:"#e8f4ff",border:"1px solid #91caff",borderRadius:6,padding:"12px 16px",marginBottom:16,display:"flex",alignItems:"flex-start",justifyContent:"space-between"}}>
        <div style={{fontSize:12,color:"#555"}}>ℹ️ 你现可通过编辑每个仓库的特定物流模板来自定义每个仓库的运费规则。你所做的任何更改都只会应用于相应仓库，不会影响其他仓库。</div>
        <span style={{cursor:"pointer",color:"#bbb",fontSize:16,flexShrink:0,marginLeft:12}}>×</span>
      </div>
      {/* 注册TikTok揽收 */}
      <div style={{background:"#fff",borderRadius:6,padding:"20px",marginBottom:16,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:16}}>
          <div style={{fontSize:40}}>🚚</div>
          <div>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:4}}>注册 TikTok 揽收服务</div>
            <div style={{fontSize:12,color:"#666",marginBottom:4}}>立即为你的仓库报名，享受专属费率、免罚和无忧物流体验。<span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #bbb",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#999",marginLeft:4}}>?</span></div>
            <div style={{fontSize:12,color:"#888"}}>仓库状态：0 个未加入</div>
          </div>
        </div>
        <button style={{background:"#21c3bc",border:"none",borderRadius:4,padding:"8px 20px",color:"#fff",fontSize:13,cursor:"pointer",fontWeight:500,flexShrink:0}}>升级</button>
      </div>
      {/* 仓库标签 */}
      <div style={{background:"#fff",borderRadius:6,overflow:"hidden"}}>
        <div style={{display:"flex",borderBottom:"1px solid #f0f0f0",padding:"0 20px"}}>
          {warehouses.map(w=>(
            <div key={w} onClick={()=>setActiveWarehouse(w)} style={{padding:"12px 16px 12px 0",marginRight:20,fontSize:13,cursor:"pointer",color:activeWarehouse===w?"#21c3bc":"#555",borderBottom:activeWarehouse===w?"2px solid #21c3bc":"2px solid transparent",fontWeight:activeWarehouse===w?500:400}}>{w}</div>
          ))}
        </div>
        <div style={{padding:"16px 20px"}}>
          {/* 成功提示 */}
          <div style={{background:"#f6ffed",border:"1px solid #b7eb8f",borderRadius:6,padding:"12px 16px",marginBottom:16,display:"flex",alignItems:"flex-start",justifyContent:"space-between"}}>
            <div style={{fontSize:12,color:"#555"}}>✅ 你的 TikTok 物流（升级版）申请已通过。请先完成全球商品升级和一品多仓配置，然后点击"切换选项"，选择"TikTok 物流（升级版）"以使用服务。新的物流方式仅对切换后收到的订单生效。</div>
            <span style={{cursor:"pointer",color:"#bbb",fontSize:16,flexShrink:0,marginLeft:12}}>×</span>
          </div>
          {/* TikTok物流 */}
          <div style={{border:"1px solid #f0f0f0",borderRadius:6,padding:"16px",marginBottom:20}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}>
              <div style={{width:36,height:36,background:"#f5f5f5",borderRadius:6,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18}}>📦</div>
              <div>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <span style={{fontWeight:600,fontSize:14,color:"#111"}}>TikTok 物流</span>
                  <span style={{background:"#21c3bc",color:"#fff",borderRadius:3,padding:"1px 8px",fontSize:11,fontWeight:500}}>升级版</span>
                </div>
                <div style={{fontSize:12,color:"#888",marginTop:2}}>你负责订单发货，我们负责后续工作。<span style={{color:"#21c3bc",cursor:"pointer",marginLeft:6}}>查看更多</span></div>
              </div>
            </div>
          </div>
          {/* 物流承运商 */}
          <div style={{marginBottom:20}}>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:4}}>物流承运商</div>
            <div style={{fontSize:12,color:"#888",marginBottom:12}}>TikTok Shop 将自动为每个订单从你同意合作的承运商中选择最合适的承运商。</div>
            <div style={{border:"1px solid #f0f0f0",borderRadius:6,overflow:"hidden"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 16px",borderBottom:"1px solid #f5f5f5"}}>
                <span style={{fontSize:13,fontWeight:500,color:"#111"}}>标准运输</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/></svg>
              </div>
              <div style={{padding:"12px 16px"}}>
                <div style={{fontSize:12,color:"#888",marginBottom:8}}>物流服务详情</div>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <span style={{background:"#f5f5f5",borderRadius:4,padding:"4px 8px",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:4}}><span style={{fontWeight:700,color:"#964B00"}}>UPS</span> Ground Saver</span>
                  <span style={{background:"#f5f5f5",borderRadius:4,padding:"4px 8px",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:4}}><span style={{color:"#e60000",fontWeight:700}}>USPS</span> Ground Advantage™.</span>
                  <span style={{background:"#f5f5f5",borderRadius:4,padding:"4px 8px",fontSize:11,color:"#555",display:"flex",alignItems:"center",gap:4}}><span style={{color:"#4d148c",fontWeight:700}}>FedEx</span> Ground Home Delivery.</span>
                  <span style={{background:"#f5f5f5",borderRadius:4,padding:"4px 8px",fontSize:11,color:"#555"}}>2+</span>
                  <span style={{marginLeft:"auto",color:"#bbb",fontSize:12}}>›</span>
                </div>
              </div>
            </div>
          </div>
          {/* 物流模板 */}
          <div>
            <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:4}}>物流模板</div>
            <div style={{fontSize:12,color:"#888",marginBottom:12}}>为每个物流选项设置运费规则。此物流模板仅适用于当前仓库。</div>
            <div style={{border:"1px solid #f0f0f0",borderRadius:6,overflow:"hidden"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"14px 16px",borderBottom:"1px solid #f5f5f5"}}>
                <span style={{fontSize:13,fontWeight:500,color:"#111"}}>X091新泽西仓_tt shipping template</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#21c3bc" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",padding:"10px 16px",background:"#fafafa",fontSize:12,color:"#888",fontWeight:500,borderBottom:"1px solid #f5f5f5"}}>
                <span>收件地</span><span>地址类型</span><span>费用</span>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr",padding:"12px 16px",fontSize:12,color:"#555"}}>
                <div>夏威夷、阿拉斯加、缅因、新罕布什尔、佛蒙特、麻萨诸塞、罗德岛... <span style={{color:"#21c3bc",cursor:"pointer"}}>Total 51 states ∨</span></div>
                <div><div>街道地址</div><div style={{marginTop:4}}>邮政信箱</div></div>
                <div><div>标准 &nbsp; $4.99</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FBTPage() {
  return (
    <div style={{padding:"20px 24px",paddingTop:0}}>
      {/* FBT使用率提示 */}
      <div style={{background:"#fff",border:"1px solid #f0f0f0",borderRadius:6,padding:"12px 20px",marginBottom:0}}>
        <div style={{fontSize:12,color:"#555",lineHeight:1.8}}>
          📢 保持较高的 FBT 使用率（实际或预计），可提高物流表现并获得额外商品曝光。<br/>
          FBT 使用率（近 7 天）：0.00% | 预计 FBT 使用率（近 30 天）：0.00% <span style={{color:"#21c3bc",cursor:"pointer"}}>查看详情</span>
        </div>
      </div>
      {/* 大横幅 */}
      <div style={{background:"linear-gradient(135deg,#1a1a2e,#16213e,#0f3460)",borderRadius:6,padding:"40px 48px",margin:"16px 0",position:"relative",overflow:"hidden",minHeight:200,display:"flex",alignItems:"center"}}>
        <div style={{position:"absolute",right:0,top:0,bottom:0,width:"40%",background:"linear-gradient(135deg,#2d5016,#1a3a0a)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:60}}>📦</div>
        <div style={{position:"absolute",bottom:16,right:16,background:"#21c3bc",color:"#fff",borderRadius:4,padding:"4px 12px",fontSize:12,fontWeight:600,transform:"rotate(-2deg)"}}>包邮三日达</div>
        <div>
          <div style={{fontWeight:700,fontSize:28,color:"#fff",marginBottom:8}}>扩展业务</div>
          <div style={{fontWeight:700,fontSize:28,color:"#fff",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
            Fulfilled by TikTok 为你助力
            <span style={{background:"#21c3bc",color:"#fff",borderRadius:4,padding:"2px 10px",fontSize:14,fontWeight:700}}>FBT</span>
          </div>
          <div style={{color:"#52c41a",fontSize:20,fontWeight:700,marginBottom:4}}>+30%</div>
          <div style={{color:"rgba(255,255,255,0.7)",fontSize:14,marginBottom:20}}>潜在曝光增加机会</div>
          <button style={{background:"#21c3bc",border:"none",borderRadius:6,padding:"10px 24px",color:"#fff",fontSize:14,cursor:"pointer",fontWeight:600}}>开始体验</button>
        </div>
      </div>
      {/* 什么是FBT */}
      <div style={{background:"#fff",borderRadius:6,padding:"24px 24px",marginBottom:16}}>
        <div style={{fontWeight:700,fontSize:18,color:"#111",marginBottom:12}}>什么是 Fulfilled by TikTok（FBT）？</div>
        <div style={{fontSize:13,color:"#555",lineHeight:1.8,marginBottom:20}}>Fulfilled by TikTok（FBT）是由 TikTok Shop 提供的一站式官方仓配服务。旨在简化你的发货流程，并通过我们在全美的履约网络帮助你为客户提供包邮三日达服务。报名加入 FBT 后，只需将商品发给我们，TikTok 将为你处理库存存储、订单拣货和打包等一切事务。</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:16}}>
          {[
            {icon:"📊",title:"提升销量",sub:"借助包邮三日达和增加的商品曝光，达成更高的 GMV。"},
            {icon:"🛡",title:"提高店铺表现",sub:"免受物流违规处罚，商品丢失或损坏可获补偿。"},
            {icon:"🔄",title:"轻松发货",sub:"享受可靠的配送速度与专业级履约服务，满足特殊业务需求。"},
          ].map(c=>(
            <div key={c.title} style={{border:"1px solid #f0f0f0",borderRadius:8,padding:"20px"}}>
              <div style={{fontSize:28,marginBottom:10}}>{c.icon}</div>
              <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:6}}>{c.title}</div>
              <div style={{fontSize:12,color:"#888",lineHeight:1.6}}>{c.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState("home");
  const [d, setD] = useState(initialData);
  const [products, setProducts] = useState(()=>loadHomeProds()||initProducts);
  useEffect(()=>{
    const base = loadHomeProds()||initProducts;
    loadHomeProdsWithImages(base).then(ps=>setProducts(ps));
  },[]);
  const [addingProduct, setAddingProduct] = useState(false);
  const [newProductName, setNewProductName] = useState("");
  const [newProductImg, setNewProductImg] = useState(null);
  const [newProductTags, setNewProductTags] = useState("");
  const [prodExp, setProdExp] = useState(false);
  const [orderExp, setOrderExp] = useState(false);
  const fileInputRefs = useRef({});
  const newFileRef = useRef();
  const [period, setPeriod] = useState("今天");
  const [showPeriodMenu, setShowPeriodMenu] = useState(false);
  const [d7, setD7] = useState(()=>loadData7d());
  const [d28, setD28] = useState(()=>loadData28d());

  const set7d = (field) => (val) => { const next={...d7,[field]:val}; setD7(next); saveData7d(next); };
  const set28d = (field) => (val) => { const next={...d28,[field]:val}; setD28(next); saveData28d(next); };

  const set = (field) => (val) => {
    let next = {...d, [field]: val};
    // 同步：GMV → 财务未结算
    if (field === 'gmv') {
      const savedFinance = loadFinance() || {netIncome:"17.08", unsettled:"19.54", totalOrders:"6"};
      saveFinance({...savedFinance, unsettled: String(Number(val).toFixed(2))});
    }
    // 同步：订单数 → 订单待发货 + 每日订单上限分子
    if (field === 'orders') {
      const num = Math.round(Number(val));
      next.pendingShip = String(num);
      // Update dailyOrderLimit numerator
      const limitParts = (d.dailyOrderLimit || '3/5').split('/');
      const denominator = limitParts[1] || '5';
      next.dailyOrderLimit = num + '/' + denominator;
    }
    // 同步：订单待发货 → 订单数 + 每日订单上限分子
    if (field === 'pendingShip') {
      const num = Math.round(Number(val));
      next.orders = num;
      const limitParts = (d.dailyOrderLimit || '3/5').split('/');
      const denominator = limitParts[1] || '5';
      next.dailyOrderLimit = num + '/' + denominator;
    }
    setD(next);
    saveData(next);
  };

  // Ctrl+Shift+Z 一键归零
  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && !e.shiftKey && e.key === 'z') {
        // Ctrl+Z 清零今天数据

        const zero = {...d, gmv:0, gmvDelta:"0%", orders:0, ordersDelta:"0%", pageViews:0, pageViewsDelta:"0%", visitors:0, visitorsDelta:"0%", pendingShip:"0"};
        setD(zero);
        saveData(zero);
      }
      if (e.ctrlKey && !e.shiftKey && e.key === 'x') {
        // Ctrl+X 清零近7天和近28天数据
        const zero7 = {...d7, gmv:0, gmvDelta:"0%", orders:0, ordersDelta:"0%", pageViews:0, pageViewsDelta:"0%", visitors:0, visitorsDelta:"0%"};
        const zero28 = {...d28, gmv:0, gmvDelta:"0%", orders:0, ordersDelta:"0%", pageViews:0, pageViewsDelta:"0%", visitors:0, visitorsDelta:"0%"};
        setD7(zero7); saveData7d(zero7);
        setD28(zero28); saveData28d(zero28);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [d]);

  const handleImgUpload=(id,file)=>{const r=new FileReader();r.onload=e=>setProducts(ps=>{const next=ps.map(p=>p.id===id?{...p,img:e.target.result}:p);saveHomeProds(next);return next;});r.readAsDataURL(file);};
  const handleNewImg=(file)=>{const r=new FileReader();r.onload=e=>setNewProductImg(e.target.result);r.readAsDataURL(file);};
  const addProduct=()=>{if(!newProductName.trim())return;const tags=newProductTags.split(",").map(t=>t.trim()).filter(Boolean);setProducts(ps=>{const next=[...ps,{id:Date.now(),name:newProductName,img:newProductImg,tags}];saveHomeProds(next);return next;});setNewProductName("");setNewProductImg(null);setNewProductTags("");setAddingProduct(false);};

  const gmvDisplay=typeof d.gmv==="number"?d.gmv.toFixed(2):d.gmv;
  const curD = period==="近 7 天" ? d7 : period==="近 28 天" ? d28 : d;
  const curSet = period==="近 7 天" ? set7d : period==="近 28 天" ? set28d : set;
  const curGmv = typeof curD.gmv==="number" ? curD.gmv.toFixed(2) : curD.gmv;
  const metrics=[
    {label:"GMV",prefix:"$",val:period==="今天"?gmvDisplay:curGmv,delta:curD.gmvDelta,vf:"gmv",df:"gmvDelta"},
    {label:"订单数",prefix:"",val:Math.round(Number(curD.orders)),delta:curD.ordersDelta,vf:"orders",df:"ordersDelta"},
    {label:"页面浏览数",prefix:"",val:Math.round(Number(curD.pageViews)),delta:curD.pageViewsDelta,vf:"pageViews",df:"pageViewsDelta"},
    {label:"平均访客数",prefix:"",val:Math.round(Number(curD.visitors)),delta:curD.visitorsDelta,vf:"visitors",df:"visitorsDelta"},
  ];

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100vh",fontFamily:"-apple-system,'PingFang SC','Helvetica Neue','Microsoft YaHei',sans-serif",fontSize:14,color:"#1a1a1a"}}>
      <div style={{background:"#121212",height:52,display:"flex",alignItems:"center",padding:"0 20px",flexShrink:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <TikTokLogo/>
          <div style={{display:"flex",flexDirection:"column",lineHeight:1,marginRight:2}}><span style={{color:"#fff",fontWeight:800,fontSize:15,letterSpacing:"-0.3px"}}>TikTok</span><span style={{color:"#fff",fontSize:10,opacity:0.85,marginTop:1}}>Shop</span></div>
          <div style={{width:1,height:18,background:"#555",margin:"0 8px"}}/>
          <span style={{color:"#fff",fontSize:14}}>商家中心</span>
        </div>
        <div style={{flex:1}}/>
        <div style={{display:"flex",alignItems:"center",gap:18}}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          <div style={{width:1,height:16,background:"#444"}}/>
          <div style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",color:"#aaa",fontSize:13}}><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg><span>客户消息</span></div>
          <div style={{cursor:"pointer"}}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#aaa" strokeWidth="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg></div>
          <div style={{display:"flex",alignItems:"center",gap:6,cursor:"pointer"}}>
            <div style={{width:28,height:28,borderRadius:"50%",background:"#2563eb",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,color:"#fff",fontWeight:600}}>N</div>
            <span style={{color:"#ddd",fontSize:13}}><EditField value={d.shopName} onChange={set("shopName")} style={{color:"#ddd"}}/></span>
            <svg width="10" height="6" viewBox="0 0 10 6" fill="#888"><path d="M0 0l5 6 5-6z"/></svg>
          </div>
        </div>
      </div>

      <div style={{display:"flex",flex:1,overflow:"hidden"}}>
        <div style={{width:178,background:"#fff",borderRight:"1px solid #ebebeb",flexShrink:0,overflowY:"auto"}}>
          <div style={{paddingTop:6}}>
            <SimpleNavItem id="home" label="首页" page={page} setPage={setPage}/>
            <SimpleNavItem id="products" label="商品" page={page} setPage={setPage}/>

            <SimpleNavItem id="orders" label="订单" page={page} setPage={setPage}/>

            <SimpleNavItem id="logistics" label="物流" page={page} setPage={setPage}/>
            <div style={{height:1,background:"#f2f2f2",margin:"4px 0"}}/>
            {NAV_MID.map(n=><SimpleNavItem key={n.id} id={n.id} label={n.label} page={page} setPage={setPage}/>)}
            <div style={{height:1,background:"#f2f2f2",margin:"4px 0"}}/>
            {NAV_BOT.map(n=><SimpleNavItem key={n.id} id={n.id} label={n.label} page={page} setPage={setPage}/>)}
          </div>
        </div>

        <div style={{flex:1,overflow:"hidden",display:"flex",flexDirection:"column"}}>
          {page==="products"?<ProductsPage/>:
           page==="orders"?<OrdersPage/>:
           page==="logistics"?<LogisticsPage/>:
           page==="ads"?<AdsPage/>:
           page==="affiliate"?<AffiliatePage/>:
           page==="health"?<HealthPage/>:
           page==="finance"?<FinancePage/>:
           page==="home"?(
            <div style={{flex:1,background:"#f5f5f5",overflowY:"auto"}}>
              <div style={{background:"#111",height:86,position:"relative",overflow:"hidden"}}>
                <div style={{position:"absolute",top:14,right:230,width:13,height:13,background:"#fe2c55",transform:"rotate(45deg)"}}/>
                <div style={{position:"absolute",top:30,right:170,width:9,height:9,background:"#25f4ee",transform:"rotate(45deg)"}}/>
                <div style={{position:"absolute",top:10,right:108,width:20,height:20,background:"#25f4ee",transform:"rotate(45deg)"}}/>
                <div style={{position:"absolute",top:34,right:360,width:7,height:7,background:"#fe2c55",transform:"rotate(45deg)"}}/>
                <div style={{position:"absolute",top:54,right:292,width:6,height:6,background:"#25f4ee",borderRadius:"50%"}}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 296px",gap:12,padding:"12px 14px"}}>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <div style={{background:"#fff",borderRadius:4,padding:"18px 20px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
                      <div style={{display:"flex",alignItems:"center",gap:10}}><span style={{fontWeight:600,fontSize:14,color:"#111"}}>经营数据</span><div style={{position:"relative"}}>
                        <div onClick={()=>setShowPeriodMenu(v=>!v)} style={{border:"1px solid #ddd",borderRadius:3,padding:"2px 9px",fontSize:12,color:"#555",cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
                          {period} <svg width="8" height="5" viewBox="0 0 8 5" fill="#888"><path d="M0 0l4 5 4-5z"/></svg>
                        </div>
                        {showPeriodMenu&&<div style={{position:"absolute",top:"100%",left:0,background:"#fff",border:"1px solid #eee",borderRadius:4,boxShadow:"0 2px 8px rgba(0,0,0,0.15)",zIndex:9999,minWidth:100,marginTop:2}}>
                          {["今天","近 7 天","近 28 天"].map(p=>(
                            <div key={p} onClick={()=>{setPeriod(p);setShowPeriodMenu(false);}} style={{padding:"9px 18px",fontSize:13,cursor:"pointer",color:period===p?"#21c3bc":"#333",background:period===p?"#f0fffe":"#fff",whiteSpace:"nowrap"}}>{p}</div>
                          ))}
                        </div>}
                      </div></div>
                      <span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>更多 &gt;</span>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)"}}>
                      {metrics.map((m,i)=>(
                        <div key={m.label} style={{paddingLeft:i>0?18:0,paddingRight:i<3?18:0,borderRight:i<3?"1px solid #f0f0f0":"none"}}>
                          <div style={{fontSize:12,color:"#888",marginBottom:10,display:"flex",alignItems:"center",gap:3}}>{m.label}<span style={{width:14,height:14,borderRadius:"50%",border:"1px solid #ddd",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"#bbb"}}>?</span></div>
                          <div style={{fontSize:24,fontWeight:700,color:"#111",marginBottom:6}}>{m.prefix}<EditField value={m.val} onChange={curSet(m.vf)}/></div>
                          <div style={{fontSize:12,color:m.delta==="--%"?"#999":"#00a870",display:"flex",alignItems:"center",gap:2}}>{m.delta!=="--%"?<><span>↑</span><EditField value={m.delta} onChange={curSet(m.df)}/></>:<span style={{color:"#999"}}>--  %</span>}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{background:"#fff",borderRadius:4,padding:"16px 20px"}}>
                    <div style={{display:"flex",alignItems:"baseline",gap:8,marginBottom:14}}><span style={{fontWeight:600,fontSize:14,color:"#111"}}>重要待办</span><span style={{fontSize:12,color:"#999"}}>以下重要待办事项影响经营指标，请尽快处理。</span></div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                      {[{label:"订单待发货",field:"pendingShip"},{label:"商品低库存",field:"lowStock"},{label:"待整改违规",field:"pendingReview"},{label:"售后待处理",field:"afterSale"},{label:"被拒商品",field:"rejected"},{label:"可申诉违规",field:"appealable"}].map(item=>(
                        <div key={item.label} style={{border:"1px solid #f0f0f0",borderRadius:3,padding:"11px 14px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}}>
                          <span style={{fontSize:13,color:"#444"}}>{item.label}</span>
                          <span style={{display:"flex",alignItems:"center",gap:5,fontSize:14,fontWeight:500,color:"#111"}}><EditField value={d[item.field]} onChange={set(item.field)}/><svg width="5" height="9" viewBox="0 0 5 9" fill="none" stroke="#ccc" strokeWidth="1.5"><path d="M1 1l3 3.5-3 3.5"/></svg></span>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div style={{background:"#fff",borderRadius:4,padding:"16px 20px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                      <div style={{display:"flex",alignItems:"baseline",gap:8}}><span style={{fontWeight:600,fontSize:14,color:"#111"}}>商机中心</span><span style={{fontSize:12,color:"#999"}}>了解平台热卖商品趋势，打造热销爆款</span></div>
                      <div style={{display:"flex",gap:10,alignItems:"center"}}><button onClick={()=>setAddingProduct(true)} style={{color:"#21c3bc",fontSize:12,cursor:"pointer",background:"none",border:"1px solid #21c3bc",borderRadius:3,padding:"3px 10px"}}>+ 添加商品</button><span style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>更多 &gt;</span></div>
                    </div>
                    {addingProduct&&<div style={{border:"1px dashed #21c3bc",borderRadius:4,padding:14,marginBottom:14,background:"#f8fffe"}}>
                      <div style={{fontWeight:500,fontSize:13,marginBottom:10}}>添加新商品</div>
                      <div style={{display:"flex",flexDirection:"column",gap:8}}>
                        <div><div style={{fontSize:12,color:"#666",marginBottom:4}}>商品名称</div><input value={newProductName} onChange={e=>setNewProductName(e.target.value)} placeholder="输入商品名称" style={{width:"100%",border:"1px solid #ddd",borderRadius:3,padding:"6px 10px",fontSize:13,outline:"none",boxSizing:"border-box"}}/></div>
                        <div><div style={{fontSize:12,color:"#666",marginBottom:4}}>商品图片</div>
                          <div onClick={()=>newFileRef.current?.click()} style={{width:100,height:80,border:"1px dashed #ccc",borderRadius:3,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",overflow:"hidden",background:"#fafafa"}}>{newProductImg?<img src={newProductImg} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg><span style={{fontSize:11,color:"#bbb",marginTop:4}}>点击上传</span></>}</div>
                          <input ref={newFileRef} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleNewImg(e.target.files[0])}/></div>
                        <div><div style={{fontSize:12,color:"#666",marginBottom:4}}>标签（逗号分隔）</div><input value={newProductTags} onChange={e=>setNewProductTags(e.target.value)} placeholder="如: TikTok 热门商品, 高热缺货" style={{width:"100%",border:"1px solid #ddd",borderRadius:3,padding:"6px 10px",fontSize:13,outline:"none",boxSizing:"border-box"}}/></div>
                        <div style={{display:"flex",gap:8,marginTop:4}}><button onClick={addProduct} style={{background:"#21c3bc",color:"#fff",border:"none",borderRadius:3,padding:"7px 18px",fontSize:13,cursor:"pointer"}}>确认添加</button><button onClick={()=>{setAddingProduct(false);setNewProductName("");setNewProductImg(null);setNewProductTags("");}} style={{background:"#fff",color:"#666",border:"1px solid #ddd",borderRadius:3,padding:"7px 14px",fontSize:13,cursor:"pointer"}}>取消</button></div>
                      </div>
                    </div>}
                    <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:10}}>
                      {products.map(p=>(
                        <div key={p.id} style={{border:"1px solid #f0f0f0",borderRadius:4,overflow:"hidden"}}>
                          <div style={{height:118,background:"#f8f8f8",position:"relative",cursor:"pointer"}} onClick={()=>fileInputRefs.current[p.id]?.click()}>
                            {p.img?<img src={p.img} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:<div style={{width:"100%",height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:6}}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg><span style={{fontSize:11,color:"#ccc"}}>点击上传图片</span></div>}
                            <input ref={el=>fileInputRefs.current[p.id]=el} type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleImgUpload(p.id,e.target.files[0])}/>
                          </div>
                          <div style={{padding:"8px 10px 10px"}}><div style={{fontSize:12,color:"#333",marginBottom:6,lineHeight:1.5}}>{p.name}</div><div style={{marginBottom:5}}>{p.tags.map(t=><span key={t} style={{display:"inline-block",background:"#fffbe6",color:"#d48806",border:"1px solid #ffe58f",borderRadius:2,fontSize:10,padding:"1px 4px",marginRight:2,marginBottom:2}}>{t}</span>)}</div><div style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>发同款</div></div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div style={{display:"flex",flexDirection:"column",gap:12}}>
                  <div style={{background:"#fff",borderRadius:4,padding:"16px 18px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:14}}><svg width="15" height="15" viewBox="0 0 24 24" fill="#21c3bc"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg><span style={{fontWeight:600,fontSize:14,color:"#111"}}>店铺健康评分</span></div>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6}}><span style={{fontSize:40,fontWeight:700,color:"#111",lineHeight:1}}><EditField value={d.healthScore} onChange={set("healthScore")}/></span><span style={{background:"#f0fff4",color:"#00a870",border:"1px solid #b7eb8f",borderRadius:3,padding:"2px 9px",fontSize:12,fontWeight:500}}>优秀</span></div>
                    <div style={{fontSize:12,color:"#666",marginBottom:13,lineHeight:1.7}}>当前账号很健康，请继续再接再厉！</div>
                    <div style={{color:"#21c3bc",fontSize:12,cursor:"pointer"}}>查看详情 &gt;</div>
                  </div>
                  <div style={{background:"#fff",borderRadius:4,padding:"16px 18px"}}>
                    <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:8}}>店铺考察期</div>
                    <div style={{fontSize:12,color:"#999",marginBottom:14,lineHeight:1.7}}>完成全部考察期任务后将解除店铺限制。</div>
                    {[{label:"每日订单上限",field:"dailyOrderLimit"},{label:"最大商品数量",field:"maxProducts"}].map(item=>(
                      <div key={item.label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:"1px solid #f5f5f5"}}>
                        <div style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:"#444"}}><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#999" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg><span>{item.label}</span></div>
                        <span style={{fontSize:13,fontWeight:500,color:"#111"}}><EditField value={d[item.field]} onChange={set(item.field)}/></span>
                      </div>
                    ))}
                    <div style={{color:"#21c3bc",fontSize:12,cursor:"pointer",marginTop:12}}>查看详情 &gt;</div>
                  </div>
                  <div style={{background:"#fff",borderRadius:4,padding:"16px 18px"}}>
                    <div style={{fontWeight:600,fontSize:14,color:"#111",marginBottom:14}}>平台政策与指南</div>
                    <div style={{background:"linear-gradient(135deg,#3b0764,#7e22ce)",borderRadius:4,padding:"12px 14px",marginBottom:12,position:"relative",overflow:"hidden"}}><div style={{position:"absolute",right:-8,top:-8,width:55,height:55,borderRadius:"50%",background:"rgba(255,255,255,0.07)"}}/><div style={{fontSize:11,color:"rgba(255,255,255,0.65)",marginBottom:2}}>TikTok Shop</div><div style={{fontSize:12,color:"#fff",fontWeight:500,lineHeight:1.5}}>商家经营产品工具箱 <span style={{color:"#ff6eb4",fontWeight:700}}>重磅发布！</span></div></div>
                    {[{type:"重要",label:"美区商家经营方法论白...",tc:"#cf1322",bg:"#fff1f0"},{type:"课程",label:"ACE产品实操课",tc:"#096dd9",bg:"#e6f4ff"},{type:"功能",label:"商家经营产品工具箱",tc:"#531dab",bg:"#f9f0ff"},{type:"课程",label:"新商启航计划",tc:"#096dd9",bg:"#e6f4ff"}].map(item=>(
                      <div key={item.label} style={{display:"flex",alignItems:"center",gap:8,padding:"9px 0",borderBottom:"1px solid #f5f5f5",cursor:"pointer"}}><span style={{background:item.bg,color:item.tc,borderRadius:2,padding:"1px 6px",fontSize:11,fontWeight:500,whiteSpace:"nowrap",flexShrink:0}}>{item.type}</span><span style={{fontSize:12,color:"#333"}}>{item.label}</span></div>
                    ))}
                  </div>
                  <div style={{background:"#fff",borderRadius:4,padding:"12px 14px",border:"1px solid #eee",position:"relative"}}><div style={{position:"absolute",top:7,right:10,cursor:"pointer",color:"#bbb",fontSize:14}}>×</div><div style={{fontSize:12,color:"#444",lineHeight:1.8}}>获取实用见解、技巧和工具，帮助您提升工作效率并简化店铺管理。</div><div style={{width:32,height:32,borderRadius:"50%",background:"#21c3bc",display:"flex",alignItems:"center",justifyContent:"center",marginTop:10,cursor:"pointer"}}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div></div>
                </div>
              </div>
            </div>
           ):(
            <div style={{flex:1,background:"#f5f5f5",display:"flex",alignItems:"center",justifyContent:"center"}}><div style={{background:"#fff",borderRadius:4,padding:"60px 40px",textAlign:"center"}}><div style={{fontSize:13,color:"#999"}}>页面建设中，敬请期待</div></div></div>
           )}
        </div>
      </div>
    </div>
  );
}
